import React, { useState, useEffect, useRef } from "react";
import {
    Button,
    Card,
    Collapse,
    Form,
    Modal,
    OverlayTrigger,
    Popover,
    Table,
    Tooltip,
} from "react-bootstrap";
import html2canvas from "html2canvas";
import './homeMaintenance.scss'
import imageCompression from 'browser-image-compression';

import DatePicker from "react-datepicker";
import serviceImg from "../../media/images/serviceImg.gif";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import creditCardType from "credit-card-type";

import DummyBackdropLoader from "../../component/backDrop/dummyBackDropLoader";
import ErrorBackdropLoader from "../../component/backDrop/errorBackDropLoader";
import BackDropLoaderWithoutUpdate from "../../component/backDrop/backDropLoaderWithoutUpdate";
import BackDrop from "../../component/backDrop/backDropLoader";
import UpdateServiceRequest from "../../component/updateServiceRequest/updateServiceRequest";
import ResponceForAPI from "../../component/backDrop/responcesForAPI";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import TextArea from "../../jsx/components/fields/textArea";
import { BsStarFill } from "react-icons/bs";
import { BiStar } from "react-icons/bi";
import { AiOutlineArrowDown, AiOutlineArrowUp } from "react-icons/ai";
import SkeletonTableRow from "../../component/skeletonTableRow/skeletonTableRow";
import PaginationAndSearching from "../../component/paginationAndSearching/paginationAndSearching";
import {
    lblEnterProblemDescription,
    txtCategory,
    txtCreatedBy,
    txtDateTime,
    txtServiceID,
    txtServiceRequests,
    txtStatus,
} from "../../dataBaseFile/label";
import {
    btnAvailableServices,
    btnMyServices,
    btnOpenJobs,
} from "../../dataBaseFile/alert";
import EmailPhoneCombine from "../../jsx/components/fields/emailPhoneField";
import { validEmail_OR_MobileNumberText } from "../../dataBaseFile/error";
import {
    emailValidation,
    noSpaceOnChange,
    phoneValidation,
} from "../../functions/validations";
import shareServiceRequest from "../../service/api/ticket/shareServiceRequest";
import ResponceToaster from "../../jsx/components/responceToaster/responceToaster";
import {
    setMyCurrentTab,
    setMyCurrentTabRedux,
} from "../../feature/serviceRequest/serviceRequestRedux";
import { getCounterApi } from "../../service/api/ticket/serviceCounters";
import { backLoaderTrue, setCurrentPage, setLoaderTime, setUserDetails } from "../../feature/userData/userData";
import CustomTable from "../../jsx/components/customTable/customTable";
import openServiceImg from '../../media/images/servicesAssets/openServiceImg.png'
import calendarImg from '../../media/images/servicesAssets/calendarImg.png'
import searchImg from '../../media/images/servicesAssets/searchImg.png'

import houseImg from '../../media/images/maintenanceAssets/houseImg.png'
import checkUpResultImg from '../../media/images/maintenanceAssets/checkUpResultImg.png'
import proInspectorImg from '../../media/images/maintenanceAssets/proInspectorImg.png'
import customerImg from '../../media/images/authAssets/customerImg.png'
import InputField from "../../jsx/components/fields/inputField";
import { getHomeAreaListApi } from "../../service/api/homeMaintenance/getHomeAreaList";
import { addNewHomeAreaApi } from "../../service/api/homeMaintenance/addNewHomeArea";
import { editHomeAreaListApi } from "../../service/api/homeMaintenance/editHomeAreaList";
import SelectInputCondition from "../../jsx/components/fields/selectInputCondition";
import { getCat } from "../../service/api/object/getCat";
import SelectInputCategories from "../../jsx/components/fields/selectInputCategories";
import { getProductType } from "../../service/api/object/getProdType";
import SelectInputProductTypes from "../../jsx/components/fields/selectInputProductTypes";
import { getAllProductTypeListApi } from "../../service/api/object/getAllProductTypeList";
import addUpdateInventoryItemApi from "../../service/api/homeMaintenance/addUpdateInventoryItem";
import deleteInventoryItemApi from "../../service/api/homeMaintenance/deleteInventoryItem";
import BackDropLoaderRejectedCase from "../../component/backDrop/backDropLoaderRejectedCase";
import CreateTicket from "../../service/api/ticket/createTicket";
import SelectInputPeriod from "../../jsx/components/fields/selectInputPeriod";
import SelectInputFrequency from "../../jsx/components/fields/selectInputFrequency";
import addUpdateMaintenancePlanApi from "../../service/api/homeMaintenance/addUpdateMaintenancePlan";
import { MdOutlineCancel, MdOutlineDocumentScanner } from "react-icons/md";
import ocr from "../../service/api/recognition/ocr";
import deleteMaintenancePlanApi from "../../service/api/homeMaintenance/deleteMaintenancePlan";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { TiSpanner } from "react-icons/ti";
import deleteNewHomeAreaApi from "../../service/api/homeMaintenance/deleteNewHomeArea";
import SkeletonDivElement from "../../component/skeletonTableRow/skeletonDivElement";
import { getPaymentMethodListByCustomerId } from "../../service/api/paymentGateway/getPaymentMethodListByCustomerId";
import { getPaymentConfigApi } from "../../service/api/paymentGateway/getPaymentConfig";
import { checkPromoCode } from "../../service/api/paymentGateway/checkPromoCode";
import { getPaymentMethodSupportedList } from "../../service/api/paymentGateway/getPaymentMethodSupportedList";
import { createPaymentMethod } from "../../service/api/paymentGateway/createPaymentMethod";
import { userById } from "../../service/api/user/userById";
import setDefaultPaymentMethodById from "../../service/api/paymentGateway/setDefaultPaymentMethodById";
import { format } from "date-fns";
import AddNewCard from "../paymentModule/addNewCard";
import { Elements, CardElement, useStripe, useElements, CardNumberElement } from '@stripe/react-stripe-js';
import { CardNumberInput, CardExpiryInput, CardCvcInput } from '../paymentModule/cardElements/cardInput';
import axios from "axios";
import StandardInputField from "../../jsx/components/fields/standardInputField";
import { isPostalCode } from "validator";


const HomeMaintenance = () => {
    const { role, permissionArr, backDropLoaderRejectedCase, backDropLoaderStatus, updateServiceRequestStatus, customerID, totalCreditsInCents } = useSelector((state) => state.user);
    const { myCurrentTab } = useSelector((state) => state.service);

    const permissionArray = permissionArr[0] || [];
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPage, setTotalPage] = useState(1);
    const [sortByValue, setSortByValue] = useState("DESC");
    const [searchValue, setSearchValue] = useState("");
    const [bulkDeleteArr, setBulkDeleteArr] = useState([]);
    const [skeltonVal, setSkeltonVal] = useState(false);
    const [columnName, setColumnName] = useState("");
    const [totalNoRecord, setTotalNoRecord] = useState(100);
    const [elements, setElements] = useState([]);
    const [inProgressElements, setInProgressElements] = useState([]);
    const [completedElements, setCompletedElemets] = useState([]);
    const [cancelledElements, setCancelledElements] = useState([]);
    const [customeSkeletonLoading, setCustomeSkeletonLoading] = useState(false);

    const [renderTicketListPro, setRenderTicketListPro] = useState(1);
    const [flag, setFlag] = useState(false);

    const [ticketID, setTicketID] = useState(null);
    const [counters, setCounters] = useState({});

    const [basicModal, setBasicModal] = useState(false);
    const [initiColor, setInitiColor] = useState(true);
    const [sortingCol, setSortingCol] = useState(true);
    const [callLogIdIds, setCallLogIdIds] = useState(null);
    const [userCallLogIdIds, setUserCallLogIdIds] = useState(null);
    const [showCallDetails, setShowCallDetails] = useState(false);
    const [sentRequest, setSentRequest] = useState([]);
    const [flagForTicket, setFlagForTicket] = useState(true);
    const [showShareServiceModal, setShowShareServiceModal] = useState(false);
    const handleShowShareServiceModal = () => setShowShareServiceModal(true);
    const [isEmailPhoneVal, setIsEmailPhoneVal] = useState(false);
    const [emailPhoneValue, setEmailPhoneValue] = useState("");
    const [codeValue, setCodeValue] = useState();
    const [isPhone, setIsPhone] = useState(false);
    const [shareLoading, setShareLoading] = useState(false);

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState("");
    const [handleToaster, setHandleToaster] = useState(false);

    const [filtreBox, setFiltreBox] = useState(false);
    const [filtreValue, SetFiltreValue] = useState(1);

    const [maintenanceInfoTrigger, setMaintenanceInfoTrigger] = useState(false);
    const [inventoryModalTrigger, setInventoryModalTrigger] = useState(false);
    const [toggleForInventoryModal, setToggleForInventoryModal] = useState(1);

    const [roomTypeName, setRoomTypeName] = useState("");
    const [isRoomTypeNameErr, setIsRoomTypeNameErr] = useState(false);
    const [roomModalTrigger, setRoomModalTrigger] = useState(false);
    const [toggleForRoomModal, setToggleForRoomModal] = useState(1);

    const [roomsLoading, setRoomsLoading] = useState(false);

    const [itemListCount, setItemListCount] = useState(0);
    const [homeId, setHomeId] = useState("");
    const [areaId, setAreaId] = useState("");
    const [homeAreaListArr, setHomeAreaListArr] = useState([]);
    const [homeAreaIdListArr, setHomeAreaIdListArr] = useState([]);

    const [refAreaListNewDesign, setRefAreaListNewDesign] = useState([]);
    const [refAreaId, setRefAreaId] = useState("");

    const [myRooms, setMyRooms] = useState([]);

    const [conditionListArr, setConditionListArr] = useState([]);
    const [periodListArr, setPeriodListArr] = useState([]);
    const [categoriesArr, setCategoriesArr] = useState([]);
    const [productTypeArr, setProductTypeArr] = useState([]);

    const [categoryId, setCategoryId] = useState("");
    const [categoryName, setCategoryName] = useState("Inspection");
    const [isCategoryIdErr, setIsCategoryIdErr] = useState(false);
    const [homeAreaProductId, setHomeAreaProductId] = useState("");
    const [inventoryType, setInventoryType] = useState("");
    const [isInventoryTypeErr, setIsInventoryTypeErr] = useState(false);
    const [inventoryTypeId, setInventoryTypeId] = useState("");
    const [inventoryBrand, setInventoryBrand] = useState("");
    const [inventoryModel, setInventoryModel] = useState("");
    const [inventorySerialNumber, setInventorySerialNumber] = useState("");
    const [inventoryCondition, setInventoryCondition] = useState("Not assessed");
    const [inventoryDesc, setInventoryDesc] = useState("");
    const [inventoryImage, setInventoryImage] = useState(null);
    const [attachedImage0, setAttachedImage0] = useState(null);
    const [uploadAttachedImage0, setUploadAttachedImage0] = useState(null);
    const [inventoryLoading, setInventoryLoading] = useState(false);

    const [errBackDropLoaderResp, setErrBackDropLoaderResp] = useState(false);
    const [backDropLoaderResp, setBackDropLoaderResp] = useState(false);
    const [timeSlotArr, setTimeSlotArr] = useState([]);
    const [comminicationModeArr, setCommunicationModeArr] = useState([]);

    const [maintenancePlanId, setMaintenancePlanId] = useState("");
    const [instruction, setInstruction] = useState("");
    const [isInstructionErr, setIsInstructionErr] = useState(false);
    const [frequency, setFrequency] = useState("");
    const [isFrequencyErr, setIsFrequencyErr] = useState(false);
    const [period, setPeriod] = useState("");
    const [isPeriodErr, setIsPeriodErr] = useState(false);
    const [purchaseLink, setPurchaseLink] = useState("");
    const [maintenancePlanLoading, setMaintenancePlanLoading] = useState(false);

    const frequencyArr = [1, 2, 3, 4, 5]

    const [isExpandedForAddMaintenance, setIsExpandedForAddMaintenance] = useState("");
    const [isExpandedForMaintenancePlan, setIsExpandedForMaintenancePlan] = useState("");
    const [isExpandedForProduct, setIsExpandedForProduct] = useState("");

    const [toggleForMaintenance, setToggleForMaintenance] = useState(1);

    const [isExpandedForAddRoom, setIsExpandedForAddRoom] = useState("");
    const [isEditForRoomName, setIsEditForRoomName] = useState('');

    const [inspectionLoading, setInspectionLoading] = useState(false);

    const [modalTriggerForInspectionConfirmation, setModalTriggerForInspectionConfirmation] = useState(false);

    const [myCountryCode, setMyCountryCode] = useState('US');

    const [isScheduledCall, setIsScheduledCall] = useState(false);

    const [userHomeAreaFlag, setUserHomeAreaFlag] = useState(1);
    const [defineRoomsLoading, setDefineRoomsLoading] = useState(false);

    const [isCreditsUsed, setIsCreditsUsed] = useState(false);


    // Attachment Upload 1
    const attachedImage0Ref = useRef();

    const handleClickAttachedImage0 = () => {
        attachedImage0Ref.current.click();
    }
    async function handleAttachedImage0(e) {
        if (e.target.files) {
            // setUploadAttachedImage0(e.target.files[0]);
            // setAttachedImage0(URL.createObjectURL(e.target.files[0]))

            const file = e.target.files[0];

            if (file && file.size > 1024 * 1024) { // Check if the file size is greater than 1 MB
                try {
                    const options = {
                        maxSizeMB: 0.5, // Maximum size in MB
                        maxWidthOrHeight: 1920, // Maximum width or height
                        useWebWorker: true, // Use web worker for faster compression
                    };
                    const compressedFile = await imageCompression(file, options);
                    // console.log('Original file size:', (file.size / 1024 / 1024).toFixed(2), 'MB');
                    // console.log('Compressed file size:', (compressedFile.size / 1024 / 1024).toFixed(2), 'MB');
                    // setSelectedFile(compressedFile);
                    setUploadAttachedImage0(compressedFile);
                    setAttachedImage0(URL.createObjectURL(compressedFile))
                } catch (error) {
                    // console.error('Error compressing the image:', error);
                }
            } else {
                setUploadAttachedImage0(file);
                setAttachedImage0(URL.createObjectURL(file));
            }
        }
    }

    function deleteAttachedImage0() {
        setUploadAttachedImage0(null);
        setAttachedImage0(null)
    }

    useEffect(() => {
        dispatch(setCurrentPage(`Maintenance`));
    }, []);


    useEffect(() => {
        if (roomModalTrigger) {
            setUserHomeAreaFlag(0)
        } else {
            setUserHomeAreaFlag(1)
        }
    }, [roomModalTrigger])

    const handleChangeRoomName = (e) => {
        setRoomTypeName(e.target.value);
        setIsRoomTypeNameErr(false);
    };

    const handleBlurCheckRoomName = (e) => {
        if (roomTypeName === "") {
            setIsRoomTypeNameErr(true);
        }
    };

    const handleClearRoomStates = () => {
        setRoomTypeName("");
        setIsRoomTypeNameErr(false);
        setAreaId('');
    }

    const handleSubmitRoomOperations = (newRoomName = '', parentAreaId = '') => {
        if (roomTypeName || newRoomName) {
            setRoomsLoading(true)

            let data = new FormData();
            data.append("area_id_ids", areaId);
            data.append("home_id_ids", homeId);
            data.append("home_area_name_chr", roomTypeName || newRoomName);
            data.append("parent_area_id_lng", parentAreaId || refAreaId);

            dispatch(
                addNewHomeAreaApi(data, (res) => {
                    // setRoomsLoading(false)
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    // setToggleForPurchase(1);

                    getHomeAreaListFn();
                    // handleCloseRoomModal();
                    handleClearRoomStates();
                    setToggleForRoomModal(1);

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                }, (err) => {
                    setRoomsLoading(false)
                    setResponceMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            )


        } else {
            setIsRoomTypeNameErr(true);
        }
    }

    const handleDeleteNewHomeAreaFn = (element) => {
        setRoomsLoading(true)
        let details = {
            home_id_ids: homeId,
            area_id_ids: element?.area_id_ids,
        };
        dispatch(
            deleteNewHomeAreaApi(details, (res) => {
                setResponceMsg(res.data.message);
                setToasterType("success")

                getHomeAreaListFn();

                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 11000);
            }, (res) => {
                setResponceMsg(res.data.message);
                setToasterType("error");
                setRoomsLoading(false);

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }
            )
        )
    }

    const handleAddRoom = (element) => {
        if (roomTypeName || isEditForRoomName) {
            handleSubmitRoomOperations()
        } else {
            handleSubmitRoomOperations(`${element?.ref_display_area_name_chr} #${element?.home_area_count + 1}`, element?.ref_area_id_ids);
        }
    }





    const handleChangeInventoryType = (e) => {
        setInventoryType(e.target.value);
        setIsInventoryTypeErr(false);
        // console.log(e.target.value, "-----------hewrewr")
    };

    useEffect(() => {
        if (inventoryType !== "") {
            productTypeArr.map((item) => {
                if (item.product_type_name_chr === inventoryType) {
                    // console.log(item.product_type_id_ids, 'item.product_type_id_ids')
                    // console.log(item.product_type_name_chr, 'item.product_type_name_chr')
                    // console.log(item.category_id_lng, 'item.category_id_lng')
                    setInventoryTypeId(item.product_type_id_ids);
                    setCategoryId(item.category_id_lng);
                }
            })
        }
    }, [inventoryType, toggleForInventoryModal]);

    const handleChangeInventoryBrand = (e) => {
        setInventoryBrand(e.target.value);
    };

    const handleChangeInventoryModel = (e) => {
        setInventoryModel(e.target.value);
    };

    const handleChangeInventorySerialNumber = (e) => {
        setInventorySerialNumber(e.target.value);

    };

    const handleChangeInventoryCondition = (e) => {
        setInventoryCondition(e.target.value);
    };

    // console.log(inventoryCondition, "inventoryCondition")

    const handleChangeInventoryDesc = (e) => {
        setInventoryDesc(e.target.value);
    };



    const handleChangeRowsPerPage = (e) => {
        setSearchValue("");
        setPage(1);
        setPageSize(e.target.value);
    };




    const [isMore, setIsMore] = useState(true);


    const handleCheckDetails = (e) => {
        // console.log(e)

        // localStorage.setItem("ticket_id", e.ticket_id_ids)
        navigate("/particularTicketDetails");
    };

    const onChangePage = (e, p) => {
        // setPage(p)
        handleToggle(null);
        setPage(e);
    };

    const handleSearch = (e) => {
        // setPage(1)
        setPage(1);
        const ele = []
        setElements(ele);
        setCancelledElements(ele);
        setInProgressElements(ele);
        setCompletedElemets(ele);
        handleToggle(null);
        if (searchValue.trim().length >= 2) {
            onChangePage(1);
            setColumnName("");
        }
        setSearchValue(e.target.value);
    };







    // With new logic
    const [expandedRow, setExpandedRow] = useState(null);

    const handleToggle = (rowIndex) => {
        if (rowIndex === expandedRow) {
            setExpandedRow(null);
        } else {
            setExpandedRow(rowIndex);
        }
    };

    const isRowExpanded = (rowIndex) => {
        return rowIndex === expandedRow;
    };

    function handleOpenFiltreBox() {
        setFiltreBox(!filtreBox);
    }

    function handleSetFiltreValue(v) {
        SetFiltreValue(v);
        const ele = [];
        setPage(1);
        setElements(ele);
        setCancelledElements(ele);
        setInProgressElements(ele);
        setCompletedElemets(ele);
        if (v === 1) {
            setSortByValue("DESC");
        } else if (v === 2) {
            setSortByValue("ASC");
        }
    }

    const scrollContainerRef = useRef(null);



    function formatUnixTimestamp(unixTimestamp) {
        const date = new Date(unixTimestamp * 1000);

        const month = date.toLocaleString("default", { month: "short" });
        const day = date.getDate();
        let hour = date.getHours();
        const minute = date.getMinutes();

        const hourFormatted = hour % 12 || 12; // Convert 24-hour time to 12-hour format
        const amPm = hour < 12 ? "am" : "pm";
        const minuteFormatted = minute < 10 ? `0${minute}` : minute;

        return `${month} ${day}, ${hourFormatted}:${minuteFormatted} ${amPm}`;
    }

    const [isExpandedItem, setIsExpandedItem] = useState(0);

    // Modal trigger functions for the maintenance info
    const handleOpenMaintenanceInfoModal = () => {
        setMaintenanceInfoTrigger(true);
    }
    const handleCloseMaintenanceInfoModal = () => {
        setMaintenanceInfoTrigger(false);
    }

    // Modal trigger functions for the inventory items
    const handleOpenInventoryModal = (val = 1) => {
        setToggleForInventoryModal(val);
        setInventoryModalTrigger(true);
        getAllProductTypeListFn();
    }
    const handleCloseInventoryModal = () => {
        setInventoryModalTrigger(false);
        handleClearInventoryStates();
    }

    // Modal trigger functions for the Room operations
    const handleOpenRoomModal = (val) => {
        setRoomModalTrigger(true);
        setToggleForRoomModal(val);
        handleClearRoomStates();
    }
    const handleCloseRoomModal = () => {
        setRoomModalTrigger(false);
        handleClearRoomStates();
        setRoomsLoading(false);
        setUserHomeAreaFlag(1);
        const intervalId = setTimeout(() => {
            setToggleForRoomModal(1);
        }, 1000)

        return () => clearInterval(intervalId)
    }


    const getHomeAreaListonContinue = () => {
        setDefineRoomsLoading(true);
        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            user_home_area_list_flag: 1,
        };
        dispatch(getHomeAreaListApi(details, (res) => {
            setDefineRoomsLoading(false);
            setRoomsLoading(false)
            // console.log(res.data);
            setHomeId(res?.user_home?.home_id_ids);
            setHomeAreaListArr(res.data);
            setRefAreaListNewDesign(res?.ref_area_list_new_design);
            res?.user_home_area_list?.length > 0 && setMyRooms(res?.user_home_area_list)
            setConditionListArr(res?.condition_list)
            setPeriodListArr(res?.period_list)
            setItemListCount(res?.item_list_count)

            setIsEditForRoomName('')

            handleCloseRoomModal();

            setHomeAreaIdListArr(simplifiedArray(res.data));
        }, (err) => {
            setDefineRoomsLoading(false);
            // console.log(err)
        }))
    }



    const getHomeAreaListFn = () => {
        setInspectionLoading(true);
        let details = {
            user_id_ids: localStorage.getItem("user_id"),
            user_home_area_list_flag: userHomeAreaFlag,
        };
        dispatch(getHomeAreaListApi(details, (res) => {
            setInspectionLoading(false);
            setRoomsLoading(false)
            // console.log(res.data);
            setHomeId(res?.user_home?.home_id_ids);
            setHomeAreaListArr(res.data);
            setRefAreaListNewDesign(res?.ref_area_list_new_design);
            res?.user_home_area_list?.length > 0 && setMyRooms(res?.user_home_area_list)
            setConditionListArr(res?.condition_list)
            setPeriodListArr(res?.period_list)
            setItemListCount(res?.item_list_count)

            setIsEditForRoomName('')

            // const simplifiedArray = res?.data?.map(item => {
            //     if (item?.home_id_lng) {
            //         return {
            //             area_id_ids: item.area_id_ids,
            //             display_area_name_chr: item.display_area_name_chr,
            //         }
            //     } 
            // });

            setHomeAreaIdListArr(simplifiedArray(res.data));
        }, (err) => {
            setInspectionLoading(false);
            // console.log(err)
        }))
    }

    useEffect(() => {
        if (toggleForMaintenance === 2) {
            handleOpenRoomModal(1)
        }
    }, [toggleForMaintenance])

    useEffect(() => {
        getHomeAreaListFn();
    }, [toggleForMaintenance])

    const simplifiedArray = (areas) => {
        return areas
            .filter(area => area.home_id_lng !== "")
            .map(area => ({
                area_id_ids: area.area_id_ids,
                display_area_name_chr: area.display_area_name_chr
            }));
    };




    useEffect(() => {
        // console.log(homeAreaIdListArr, "homeAreaIdListArr")
    }, [homeAreaIdListArr])

    // Function to handle checkbox change
    const handleCheckboxChange = (item) => {
        setHomeAreaIdListArr((prevState) => {
            // Check if the item is already in the list
            const itemIndex = prevState.findIndex(({ area_id_ids }) => area_id_ids === item.area_id_ids);

            // If item is found, remove it from the state, else add it
            if (itemIndex !== -1) {
                return prevState.filter(({ area_id_ids }) => area_id_ids !== item.area_id_ids);
            } else {
                return [...prevState,
                {
                    area_id_ids: item.area_id_ids,
                    display_area_name_chr: item.display_area_name_chr
                }
                ];
            }
        });
    };

    // Function to check if an item is selected
    const isChecked = (item) => homeAreaIdListArr.some(({ area_id_ids }) => area_id_ids === item.area_id_ids);

    const editHomeAreaListFn = () => {
        setRoomsLoading(true)
        let details = {
            home_id_ids: homeId,
            home_area_id_list: homeAreaIdListArr,
        }

        dispatch(
            editHomeAreaListApi(
                details,
                (res) => {
                    setRoomsLoading(false)
                    // console.log(res.message)
                    setResponceMsg(res.message)
                    setToasterType("success")
                    // setToggleForPurchase(1);

                    getHomeAreaListFn();
                    handleCloseRoomModal();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                }, (err) => {
                    setRoomsLoading(false)
                    setResponceMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }))
    }

    const getAllProductTypeListFn = () => {
        let detail = {
            area_id_ids: areaId,
        }

        dispatch(
            getAllProductTypeListApi(
                detail,
                (res) => {
                    // console.log(res.data.data)
                    setProductTypeArr(res.data.data)
                },
                (err) => {

                }
            )
        );
    }



    // console.log(categoriesArr, "-----categoriesArr----")
    // console.log(categoryId, "-----categoryId id----")

    // console.log(inventoryType, "-----inventoryType----")

    const handleChangeCategory = (e) => {
        setCategoryId(e.target.value)
        setIsCategoryIdErr(false)
    }


    const addUpdateinventoryItemFn = () => {
        if (inventoryType === "") {
            setIsInventoryTypeErr(true)
        } else {
            setInventoryLoading(true)

            // console.log(inventoryModel, "inventoryModel")

            const data = new FormData();
            data.append("home_area_product_id_ids", homeAreaProductId)
            data.append("product_id_ids", inventoryTypeId);
            data.append("product_name_chr", inventoryType);
            data.append("category_id_ids", (categoryId !== "null" && categoryId !== null) ? categoryId : 0);
            data.append("home_id_ids", homeId);
            data.append("area_id_ids", areaId);
            data.append("model_number_chr", inventoryModel || ``);
            data.append("serial_number_chr", inventorySerialNumber || ``);
            data.append("device_brand_chr", inventoryBrand || ``);
            data.append("description_chr", inventoryDesc || ``);
            data.append("condition_chr", inventoryCondition);
            uploadAttachedImage0 != null && data.append("attachment0", uploadAttachedImage0, "attachment.jpeg");
            uploadAttachedImage0 != null && data.append("attachment_id_ids0", "");

            dispatch(
                addUpdateInventoryItemApi(data, (res) => {
                    setInventoryLoading(false)
                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    handleCloseInventoryModal();

                    getHomeAreaListFn();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                }, (err) => {
                    setInventoryLoading(false)
                    setResponceMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            );
        }



        // handleCloseInventoryModal();
    }

    const handleClearInventoryStates = () => {
        setCategoryId("");
        setCategoryName("Inspection");
        setInventoryType("");
        setIsCategoryIdErr(false);
        setIsInventoryTypeErr(false);
        setInventoryBrand("");
        setInventoryModel("");
        setInventorySerialNumber("");
        setInventoryCondition("Not assessed");
        setInventoryDesc("");
        setInventoryImage(null);
        deleteAttachedImage0();

        setProductTypeArr([]);
        setHomeAreaProductId('');
    }

    const [imageAttachURL, setImageAttachURL] = useState('');
    const [openDoc, setOpenDoc] = React.useState(false);
    const handleOpenDoc = () => {
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);

    // Edit and delete of inventory item
    const popover = (index) => (
        <Popover
            // id="popover-basic"
            id={`popover-basic-${index}`}

            //   className="custom-popover"
            style={{ minWidth: "100px", border: 'none' }}
        >
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",

                }}>
                <div className="d-flex flex-column font-w500 fs-6" style={{}}>
                    <div
                        onClick={(e) => {
                            // editExpertise(e, expertiseObject);
                            e.stopPropagation();
                            updateInventoryItemFn();
                            setActivePopover(null);
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>Edit</span>
                    </div>
                    <div
                        onClick={(e) => {
                            // handleOpenExpertiseTrigger(e, 3, expertiseObject.expertise_id_ids);
                            e.stopPropagation();
                            handleOpenInventoryModal(3);
                            setInventoryType(individualProductObj?.product_name_chr);
                            setHomeAreaProductId(individualProductObj?.home_area_product_id_ids);
                            setActivePopover(null);
                        }}
                        className=' cursor-pointer p-2 text-danger overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>Delete</span>
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const [activePopover, setActivePopover] = useState(null);
    const [individualProductObj, setIndividualProductObj] = useState({});

    // console.log("individualProductObj->", individualProductObj)

    const handleMenuClick = (element, ind) => {
        setIndividualProductObj(element)
        setActivePopover(activePopover === ind ? null : ind)
    }

    const updateInventoryItemFn = () => {
        setHomeAreaProductId(individualProductObj?.home_area_product_id_ids);
        setInventoryTypeId(individualProductObj?.product_id_lng);
        setInventoryType(individualProductObj?.product_name_chr);
        setCategoryId(0);
        setCategoryName(individualProductObj?.category_name_chr);
        // setHomeId(individualProductObj?.home_id_ids);
        setAreaId(individualProductObj?.home_area_id_lng);
        setInventoryModel(individualProductObj?.model_number_chr);
        setInventorySerialNumber(individualProductObj?.serial_number_chr);
        setInventoryBrand(individualProductObj?.device_brand_chr);
        setInventoryDesc(individualProductObj?.description_chr);
        setInventoryCondition(individualProductObj?.condition_chr);
        setInventoryImage(individualProductObj?.image_url);
        deleteAttachedImage0();

        handleOpenInventoryModal(2);
    }

    const deleteInventoryItemFn = () => {
        setInventoryLoading(true);
        let details = {
            home_area_product_id_ids: homeAreaProductId,
        };
        dispatch(
            deleteInventoryItemApi(details, (res) => {
                setResponceMsg(res.data.message);
                setToasterType("success")
                setInventoryLoading(false);

                getHomeAreaListFn();
                handleCloseInventoryModal();

                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 11000);
            }, (res) => {
                setResponceMsg(res.data.message);
                setToasterType("error");
                setInventoryLoading(false);

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }
            )
        )
    }

    // Create the service request for the insections
    const createServiceRequestFn = () => {
        let createTicketData = new FormData();

        createTicketData.append("user_id_ids", localStorage.getItem("user_id"));
        // createTicketData.append("address_id_ids",0)
        //  !predictionFlag && productNameForTicket && createTicketData.append("object_name_chr",productNameForTicket)
        // createTicketData.append("object_name_chr", productNameForTicket ? productNameForTicket : predictedObjectClassName);
        inventoryType && createTicketData.append("object_name_chr", inventoryType);
        createTicketData.append("object_category_chr", categoryName || "Inspection");
        inventoryModel && createTicketData.append("object_model_number_chr", inventoryModel);
        inventoryDesc && createTicketData.append("problem_description_chr", inventoryDesc);
        inventoryBrand && createTicketData.append("device_brand_chr", inventoryBrand);
        // deviceColorChr && createTicketData.append("device_color_chr", deviceColorChr);
        // inventoryImage && createTicketData.append("attachment0", inventoryImage, "uploadAttachedImage0.jpeg");
        // uploadAttachedImage1 != null && createTicketData.append("attachment1", uploadAttachedImage1, "uploadAttachedImage1.jpeg");
        // uploadAttachedImage2 != null && createTicketData.append("attachment2", uploadAttachedImage2, "uploadAttachedImage2.jpeg");
        // verifiedPromoCode && createTicketData.append("amount_after_discount", finalAmountAfterPromoCodeApplied);
        homeAreaProductId && createTicketData.append("home_area_product_id_ids", homeAreaProductId);
        createTicketData.append(
            "amount_after_discount",
            finalAmountAfterPromoCodeApplied
        );

        isCreditsUsed && createTicketData.append("use_credits_flag", isCreditsUsed);

        verifiedPromoCode && createTicketData.append("promo_code_applied", verifiedPromoCode);

        setBackDropLoaderResp(true);
        dispatch(
            CreateTicket(
                createTicketData,
                (res) => {
                    localStorage.setItem("ticket_id", res.data.data.ticket_id_ids);
                    localStorage.setItem("proType", res.data.data.product_type_chr);

                    dispatch(setLoaderTime(res.data));

                    setBackDropLoaderResp(false);
                    dispatch(backLoaderTrue());

                    setTimeSlotArr(res.data.time_slot);
                    setCommunicationModeArr(res.data.communication_mode);
                    setResponceMsg(res.data.message);
                    //   setResponseAfterSubmit(res.data.message);
                    handleCloseInventoryModal();
                },
                (res) => {
                    //   setResponseAfterSubmit(res.data.message);
                    setResponceMsg(res.data.message);
                    setBackDropLoaderResp(false);
                    setErrBackDropLoaderResp(true);

                    setTimeout(() => {
                        setErrBackDropLoaderResp(false);
                    }, 2500);
                }
            )
        );
    }

    const createServiceForInventoryItems = (item) => {
        setHomeAreaProductId(item?.home_area_product_id_ids);
        setInventoryTypeId(item?.product_id_lng);
        setInventoryType(item?.product_name_chr);
        setCategoryId(0);
        setCategoryName(item?.category_name_chr);
        // setHomeId(individualProductObj?.home_id_ids);
        setAreaId(item?.home_area_id_lng);
        setInventoryModel(item?.model_number_chr);
        setInventorySerialNumber(item?.serial_number_chr);
        setInventoryBrand(item?.device_brand_chr);
        setInventoryDesc(item?.description_chr);
        setInventoryCondition(item?.condition_chr);
        setInventoryImage(item?.image_url);
        deleteAttachedImage0();

        handleOpenInventoryModal(4);
    }

    // Add maintenance plan functions
    const handleChangeInstruction = (e) => {
        setInstruction(e.target.value);
        setIsInstructionErr(false);
    }

    const handleBlurCheckInstrction = () => {
        if (instruction === "") {
            setIsInstructionErr(true);
        }
    }

    const handleChangeFreq = (e) => {
        setFrequency(e.target.value);
        setIsFrequencyErr(false);
    }

    const handleChangePeriod = (e) => {
        setPeriod(e.target.value);
        setIsPeriodErr(false);
    }

    const handleChangePurchaseLink = (e) => {
        setPurchaseLink(e.target.value);
    }

    const addUpdateMaintenancePlanFn = () => {
        if (instruction === "") {
            setIsInstructionErr(true);
        }
        if (frequency === "") {
            setIsFrequencyErr(true);
        }
        if (period === "") {
            setIsPeriodErr(true);
        }

        if (instruction !== "" && frequency !== "" && period !== "") {
            // console.log("addUpdateMaintenancePlanFn")
            // console.log("instruction", instruction)
            // console.log("frequency", frequency)
            // console.log("period", period)
            // console.log("purchase link", purchaseLink)

            setMaintenancePlanLoading(true);

            let data = new FormData();
            data.append("maintenance_plan_id_ids", maintenancePlanId);
            data.append("home_area_product_id_ids", homeAreaProductId);
            data.append("instruction_chr", instruction);
            data.append("frequency_int", frequency);
            data.append("period_int", period);
            data.append("purchase_link", purchaseLink);

            dispatch(
                addUpdateMaintenancePlanApi(data, (res) => {
                    setMaintenancePlanLoading(false)
                    setResponceMsg(res.data.message)
                    setToasterType("success")

                    clearMaintenancePlanStates();
                    setIsExpandedForAddMaintenance('');

                    getHomeAreaListFn();

                    handleCloseMaintenancePlanModal();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);

                }, (err) => {
                    setMaintenancePlanLoading(false)
                    setResponceMsg(err.data.message)
                    setToasterType("error")

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
            )

        }
    }

    const clearMaintenancePlanStates = () => {
        setMaintenancePlanId("");
        setInstruction("");
        setFrequency("");
        setPeriod("");
        setPurchaseLink("");
        setIsInstructionErr(false);
        setIsFrequencyErr(false);
        setIsPeriodErr(false);
    }

    // Functions for the OCR
    const [ocrModalTrigger, setOcrModalTrigger] = useState(false);
    const handleOpenOcrModal = () => {
        setOcrModalTrigger(true);
        setInventoryModalTrigger(false);
    };
    const handleCloseOcrModal = () => {
        setOcrModalTrigger(false);
        setInventoryModalTrigger(true);
        // stopCameraOcr();
        stopCamera();
    };

    const videoRefOcr = useRef(null);
    const canvasRefOcr = useRef(null);
    const cropRef = useRef(null);
    const [streamOcr, setStreamOcr] = useState(null);
    const [imageForOcr, setImageForOcr] = useState(null);
    const [capturedImage, setCapturedImage] = useState("");
    const [ocrLoading, setOcrLoading] = useState(false);
    const [isCameraAllowed, setIsCameraAllowed] = useState(true);
    const [crop, setCrop] = useState({ x: 50, y: 50, width: 200, height: 200 });

    // console.log(imageForOcr, 'imageForOcr')

    // Access the device camera
    const startCameraOcr = async () => {
        try {
            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: { facingMode: "environment" },
            });
            setIsCameraAllowed(true);
            setStreamOcr(mediaStream);
            if (videoRefOcr.current) {
                videoRefOcr.current.srcObject = mediaStream;
            }
        } catch (error) {
            // console.error("Error accessing the camera", error);
            // alert("Error accessing the camera, please allow camera access");
            setIsCameraAllowed(false);
        }
    };

    // Stop the camera by stopping all tracks on the stream
    const stopCameraOcr = () => {
        if (streamOcr) {
            streamOcr.getTracks().forEach((track) => track.stop());
            setStreamOcr(null); // Update the state to reflect that the stream has been stopped
        }
    };

    // Capture the image
    const captureImageOcr = () => {
        if (canvasRefOcr.current && videoRefOcr.current) {
            canvasRefOcr.current.width = videoRefOcr.current.videoWidth;
            canvasRefOcr.current.height = videoRefOcr.current.videoHeight;

            const context = canvasRefOcr.current.getContext("2d");
            context.drawImage(
                videoRefOcr.current,
                0,
                0,
                canvasRefOcr.current.width,
                canvasRefOcr.current.height
            );
            const imageUrl = canvasRefOcr.current.toDataURL("image/jpeg");
            setCapturedImage(imageUrl); // Save the captured image's data URL to state

            canvasRefOcr.current.toBlob(
                (blob) => {
                    // sendImageToAPI(blob);
                    setImageForOcr(blob);
                    // handleOcr(blob);
                },
                "image/jpeg",
                0.95
            ); // Adjust image format and quality as needed

            // Pause the video element
            if (videoRefOcr.current) {
                let newInstanceVideo = videoRefOcr.current;
                newInstanceVideo.pause()
            }

            // Display the last captured image
            if (videoRefOcr.current) {
                videoRefOcr.current.srcObject = null;
                videoRefOcr.current.src = imageUrl;
            }
        }
    };

    const handleOcr = (blob) => {
        setOcrLoading(true);

        let formData = new FormData();

        formData.append("image", blob);

        dispatch(
            ocr(
                formData,
                (res) => {
                    // console.log(res?.data?.data?.['Model number'], "res?.data?.data?.['Model number']");
                    setOcrLoading(false);

                    res?.data?.data?.predicted_object_brand && setInventoryBrand(res?.data?.data?.predicted_object_brand);
                    res?.data?.data?.predicted_object_model_number && setInventoryModel(res?.data?.data?.predicted_object_model_number);
                    res?.data?.data?.predicted_object_serial_number && setInventorySerialNumber(res?.data?.data?.predicted_object_serial_number);

                    handleCloseOcrModal();

                    if (!res?.data?.data?.predicted_object_model_number && !res?.data?.data?.predicted_object_brand && !res?.data?.data?.predicted_object_serial_number) {
                        setResponceMsg(
                            "We are unable to capture the data, please try again or enter manually."
                        );
                        setToasterType("info");

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                },
                (res) => {
                    // console.log(res);
                    setOcrLoading(false);

                    setResponceMsg(res.data.message);
                    setToasterType("error");

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    };

    const handleMouseDown = (e) => {
        e.preventDefault();
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    };

    const handleMouseMove = (e) => {
        const rect = cropRef.current.getBoundingClientRect();
        const deltaX = e.clientX - rect.left;
        const deltaY = e.clientY - rect.top;

        setCrop((prev) => ({
            ...prev,
            width: Math.max(50, deltaX),
            height: Math.max(50, deltaY),
        }));
    };

    const handleMouseUp = () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
    };

    // New functions for the croping images for the OCR module --------->>>>>>>>>>
    const [videoWidth, setVideoWidth] = useState();
    const [videoHeight, setVideoHeight] = useState();
    const [stream, setStream] = useState(null);
    const videoRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [image, setImage] = useState("");
    const [displayImage, setDisplayImage] = useState();
    const [canvasEnabled, setCanvasEnabled] = useState(false);

    useEffect(() => {
        if (window.innerWidth > 520) {
            setVideoWidth(480);
            setVideoHeight(400);
        }
        if (window.innerWidth < 520 && window.innerWidth > 360) {
            setVideoWidth(450);
            setVideoHeight(400);
        }

        if (window.innerWidth < 360) {
            setVideoWidth(359);
            setVideoHeight(359);
        }
    }, []);
    window.addEventListener("resize", () => {
        if (window.innerWidth > 520) {
            setVideoWidth(480);
            setVideoHeight(400);
        }
        if (window.innerWidth < 520 && window.innerWidth > 360) {
            setVideoWidth(450);
            setVideoHeight(400);
        }

        if (window.innerWidth < 360) {
            setVideoWidth(359);
            setVideoHeight(359);
        }
    });

    async function getMediaStream() {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: {
                    facingMode: ["environment"],
                },
            });
            setIsCameraAllowed(true);
            setStream(stream);

            const videoTrack = stream.getVideoTracks()[0];
            setTrack(videoTrack);

        } catch (error) {
            // console.error("Error accessing media devices", error);
            setIsCameraAllowed(false);
        }
    }
    // useEffect(() => {
    //     getMediaStream();
    // }, []);

    useEffect(() => {
        if (stream && videoRef.current) {
            videoRef.current.srcObject = stream;
            videoRef.current.play();
        }
    }, [stream]);

    useEffect(() => {
        return () => {
            if (stream) {
                stream.getTracks().forEach((track) => track.stop());
            }
        };
    }, [stream]);

    const stopCamera = () => {
        if (stream) {
            stream.getTracks().forEach((track) => track.stop());
            setStream(null); // Update the state to reflect that the stream has been stopped
        }
    };

    useEffect(() => {
        var canvas = document.getElementById("canvasFrame");
        if (canvas) {
            var ctx = canvas.getContext("2d");

            ctx.strokeStyle = "red";
            ctx.lineWidth = 2;
            ctx.shadowColor = "yellow";
            ctx.shadowBlur = 10;

            var imageSave;
            // calculate where the canvas is on the window
            // (used to help calculate mouseX/mouseY)

            var canvasOffset = canvas.getBoundingClientRect();

            var offsetX = canvasOffset.left;
            var offsetY = canvasOffset.top;

            // this flage is true when the user is dragging the mouse
            var isDown = false;

            // these vars will hold the starting mouse position
            var startX;
            var startY;

            var x1 = null;
            var x2 = null;
            var y1 = null;
            var y2 = null;

            function handleMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();

                // save the starting x/y of the rectangle
                startX = parseInt(e.clientX - offsetX);
                startY = parseInt(e.clientY - offsetY);

                isDown = true;
            }

            function handleMouseUp(e) {
                e.preventDefault();
                e.stopPropagation();

                // setScanImageCheck(false);

                isDown = false;
                // setLoading(true);

                html2canvas(document.getElementById("canvasFinalImage"))
                    .then((canvas) => {
                        canvas.style.display = "none";
                        document.body.appendChild(canvas);
                        return canvas;
                    })
                    .then((canvas) => {
                        const imageD = canvas.toDataURL();
                        setDisplayImage(imageD);
                        // const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
                        // console.log(image)

                        const image = canvas
                            .toDataURL("image/png")
                            .replace("data:", "")
                            .replace(/^.+,/, "");

                        const byteCharacters = atob(image);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }

                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray]);

                        setImage(blob);

                        // let formData = new FormData();

                        // formData.append("image", blob);

                        let newInstanceVideo = videoRef.current;
                        setCanvasEnabled(false);
                        newInstanceVideo.pause();

                        handleOcr(blob)

                    });
            }

            function handleMouseOut(e) {
                e.preventDefault();
                e.stopPropagation();

                // the drag is over, clear the dragging flag
                isDown = false;
            }

            function handleMouseMove(e) {
                e.preventDefault();
                e.stopPropagation();

                // if we're not dragging, just return
                if (!isDown) {
                    return;
                }

                // get the current mouse position
                var mouseX = parseInt(e.clientX - offsetX);
                var mouseY = parseInt(e.clientY - offsetY);

                // Put your mousemove stuff here

                // clear the canvas
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // calculate the rectangle width/height based
                // on starting vs current mouse position
                var width = mouseX - startX;
                var height = mouseY - startY;

                ctx.strokeRect(startX, startY, width, height);
                var video = document.getElementById("videoFrame");
                var canvasImage = document.getElementById("canvasImage");
                var ctxImage = canvasImage.getContext("2d");

                ctxImage.drawImage(video, 0, 0, videoWidth, videoHeight);

                var fImage = document.getElementById("canvasFinalImage");

                fImage.width = Math.abs(width);
                fImage.height = Math.abs(height);
                var ctxFImage = fImage.getContext("2d");

                if (Math.sign(width) == -1 && Math.sign(height) == 1) {
                    ctxFImage.drawImage(
                        canvasImage,
                        startX - Math.abs(width),
                        startY,
                        Math.abs(width),
                        Math.abs(height),
                        0,
                        0,
                        Math.abs(width),
                        Math.abs(height)
                    );
                }
                if (Math.sign(height) == -1 && Math.sign(width) == 1) {
                    ctxFImage.drawImage(
                        canvasImage,
                        startX,
                        startY - Math.abs(height),
                        Math.abs(width),
                        Math.abs(height),
                        0,
                        0,
                        Math.abs(width),
                        Math.abs(height)
                    );
                }
                if (Math.sign(height) == -1 && Math.sign(width) == -1) {
                    ctxFImage.drawImage(
                        canvasImage,
                        startX - Math.abs(width),
                        startY - Math.abs(height),
                        Math.abs(width),
                        Math.abs(height),
                        0,
                        0,
                        Math.abs(width),
                        Math.abs(height)
                    );
                }
                if (Math.sign(height) == 1 && Math.sign(width) == 1) {
                    ctxFImage.drawImage(
                        canvasImage,
                        startX,
                        startY,
                        Math.abs(width),
                        Math.abs(height),
                        0,
                        0,
                        Math.abs(width),
                        Math.abs(height)
                    );
                }
            }

            function handleTouchStart(e) {
                e.preventDefault();
                e.stopPropagation();

                // save the starting x/y of the rectangle
                startX = parseInt(e.touches[0].clientX - offsetX);
                startY = parseInt(e.touches[0].clientY - offsetY);

                isDown = true;
            }

            function handleTouchEnd(e) {
                e.preventDefault();
                e.stopPropagation();

                // setScanImageCheck(false);

                isDown = false;
                // setLoading(true);

                html2canvas(document.getElementById("canvasFinalImage"))
                    .then((canvas) => {
                        canvas.style.display = "none";
                        document.body.appendChild(canvas);
                        return canvas;
                    })
                    .then((canvas) => {
                        const imageD = canvas.toDataURL();
                        setDisplayImage(imageD);
                        // const image = canvas.toDataURL("image/png").replace("image/png", "image/octet-stream");
                        // console.log(image)

                        const image = canvas
                            .toDataURL("image/png")
                            .replace("data:", "")
                            .replace(/^.+,/, "");

                        const byteCharacters = atob(image);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }

                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray]);

                        setImage(blob);

                        // let formData = new FormData();

                        // formData.append("image", blob);

                        let newInstanceVideo = videoRef.current;
                        setCanvasEnabled(false);
                        newInstanceVideo.pause();

                        handleOcr(blob)

                    });
            }

            function handleTouchMove(e) {
                e.preventDefault();
                e.stopPropagation();

                // if we're not dragging, just return
                if (!isDown) {
                    return;
                }

                // startX = parseInt(e.touches[0].clientX - offsetX);
                // startY = parseInt(e.touches[0].clientY - offsetY);

                // get the current mouse position
                var mouseX = parseInt(e.touches[0].clientX - offsetX);
                var mouseY = parseInt(e.touches[0].clientY - offsetY);

                // Put your mousemove stuff here

                // clear the canvas
                ctx.clearRect(0, 0, canvas.width, canvas.height);

                // calculate the rectangle width/height based
                // on starting vs current mouse position
                var width = mouseX - startX;
                var height = mouseY - startY;

                ctx.strokeRect(startX, startY, width, height);
                var video = document.getElementById("videoFrame");
                var canvasImage = document.getElementById("canvasImage");
                var ctxImage = canvasImage.getContext("2d");

                ctxImage.drawImage(video, 0, 0, videoWidth, videoHeight);

                var fImage = document.getElementById("canvasFinalImage");

                fImage.width = Math.abs(width);
                fImage.height = Math.abs(height);
                var ctxFImage = fImage.getContext("2d");

                if (Math.sign(width) == -1 && Math.sign(height) == 1) {
                    ctxFImage.drawImage(
                        canvasImage,
                        startX - Math.abs(width),
                        startY,
                        Math.abs(width),
                        Math.abs(height),
                        0,
                        0,
                        Math.abs(width),
                        Math.abs(height)
                    );
                }
                if (Math.sign(height) == -1 && Math.sign(width) == 1) {
                    ctxFImage.drawImage(
                        canvasImage,
                        startX,
                        startY - Math.abs(height),
                        Math.abs(width),
                        Math.abs(height),
                        0,
                        0,
                        Math.abs(width),
                        Math.abs(height)
                    );
                }
                if (Math.sign(height) == -1 && Math.sign(width) == -1) {
                    ctxFImage.drawImage(
                        canvasImage,
                        startX - Math.abs(width),
                        startY - Math.abs(height),
                        Math.abs(width),
                        Math.abs(height),
                        0,
                        0,
                        Math.abs(width),
                        Math.abs(height)
                    );
                }
                if (Math.sign(height) == 1 && Math.sign(width) == 1) {
                    ctxFImage.drawImage(
                        canvasImage,
                        startX,
                        startY,
                        Math.abs(width),
                        Math.abs(height),
                        0,
                        0,
                        Math.abs(width),
                        Math.abs(height)
                    );
                }
            }

            function handleTouchCancel(e) {
                e.preventDefault();
                e.stopPropagation();

                // the drag is over, clear the dragging flag
                isDown = false;
            }

            document
                .getElementById("canvasFrame")
                .addEventListener("mousedown", function (e) {
                    handleMouseDown(e);
                });
            document
                .getElementById("canvasFrame")
                .addEventListener("mousemove", function (e) {
                    handleMouseMove(e);
                });
            document
                .getElementById("canvasFrame")
                .addEventListener("mouseup", function (e) {
                    handleMouseUp(e);
                });
            document
                .getElementById("canvasFrame")
                .addEventListener("mouseout", function (e) {
                    handleMouseOut(e);
                });

            document
                .getElementById("canvasFrame")
                .addEventListener("touchstart", function (e) {
                    handleTouchStart(e);
                });
            document
                .getElementById("canvasFrame")
                .addEventListener("touchmove", function (e) {
                    handleTouchMove(e);
                });
            document
                .getElementById("canvasFrame")
                .addEventListener("touchend", function (e) {
                    // console.log("Touch end");
                    handleTouchEnd(e);
                });
            document
                .getElementById("canvasFrame")
                .addEventListener("touchcancel", function (e) {
                    // console.log("touchcancel");
                    handleTouchCancel(e);
                });
        }

        window.addEventListener("resize", () => {
            setCanvasEnabled(false);
        });
    }, [canvasEnabled]);


    const canvasEnableFn = () => {
        setCanvasEnabled(!canvasEnabled);
        if (!canvasEnabled) {
            let newInstanceVideo = videoRef.current;

            newInstanceVideo.pause();
        }
        if (canvasEnabled) {
            let newInstanceVideo = videoRef.current;

            newInstanceVideo.play();
        }
    };


    // Toggle flash-light needs to work with torch
    const [flashlightOn, setFlashlightOn] = useState(false);
    const [track, setTrack] = useState(null);

    const toggleFlashlight = async () => {
        if (track) {
            const capabilities = track.getCapabilities();
            if (capabilities.torch) {
                const imageCapture = new ImageCapture(track);
                const photoCapabilities = await imageCapture.getPhotoCapabilities();
                if (photoCapabilities.torch) {
                    await track.applyConstraints({
                        advanced: [{ torch: !flashlightOn }],
                    });
                    setFlashlightOn(!flashlightOn);
                }
            }
        }
    };

    // Functions for the maintenance plans 
    const [maintenanceModalTrigger, setMaintenanceModalTrigger] = useState(false);
    const [toggleForMaintenancePlan, setToggleForMaintenancePlan] = useState(1);

    const handleOpenMaintenancePlanModal = (val = 1) => {
        setMaintenanceModalTrigger(true);

        setToggleForMaintenancePlan(val);
    }

    const handleCloseMaintenancePlanModal = () => {
        setMaintenanceModalTrigger(false);

        clearMaintenancePlanStates();
    }

    const updateMaitenancePlanFn = (data) => {
        setMaintenancePlanId(data?.maintenance_plan_id_ids);
        setInstruction(data?.instruction_chr);
        setFrequency(data?.frequency_int);
        setPeriod(data?.period_int);
        setPurchaseLink(data?.purchase_link);

        handleOpenMaintenancePlanModal(1);
    }

    const deletemaintenancePlanFn = (data) => {

        setMaintenancePlanLoading(true);
        let details = {
            maintenance_plan_id_ids: maintenancePlanId,
        };
        dispatch(
            deleteMaintenancePlanApi(details, (res) => {
                setResponceMsg(res.data.message);
                setToasterType("success")
                setMaintenancePlanLoading(false);

                getHomeAreaListFn();
                handleCloseMaintenancePlanModal();

                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 11000);
            }, (res) => {
                setResponceMsg(res.data.message);
                setToasterType("error");
                setMaintenancePlanLoading(false);

                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 11000);
            }
            )
        )
    }

    // functions for confirmation of insepection service
    const handleOpenInsectionConfirmationModal = () => {
        setModalTriggerForInspectionConfirmation(true);
    }

    const handleCloseInsectionConfirmationModal = () => {
        setModalTriggerForInspectionConfirmation(false);
    }

    // Here all Payment module integration

    const [paymentModal, setPaymentModal] = useState(false);
    const [cardInfo, setCardInfo] = useState({
        cardNumber: "",
        expiryDate: "",
        cvc: "",
        cardHolder: "",
        focus: "",
    });
    const [isCardHolderNameErr, setIsCardHolderNameErr] = useState(false);
    const [isCardNumberErr, setIsCardNumberErr] = useState(false);
    const [isCardExpErr, setIsCardExpErr] = useState(false);
    const [isCardCVCErr, setIsCardCVCErr] = useState(false);


    const [apiResponce, setApiResponse] = useState(false);

    const handleCardNumberChange = (e) => {
        setIsCardNumberErr(false);
        // Remove anything that's not a digit
        const newValue = e.target.value.replace(/\D/g, "");

        // Add spaces after every 4 digits for display
        const formattedValue = newValue.replace(/(\d{4})/g, "$1 ").trim();

        // Update the actual input value
        e.target.value = formattedValue;

        setFormatedNumber(formattedValue);

        // Update state without spaces
        setCardInfo({
            ...cardInfo,
            cardNumber: newValue,
        });
    };

    const handleExpiryDateChange = (e) => {
        setIsCardExpErr(false);
        let value = e.target.value.replace(/\D/g, "");
        if (value.length > 4) value = value.substr(0, 4); // Maximum length of 4 digits
        if (value.length > 2) value = value.substr(0, 2) + "/" + value.substr(2); // Insert slash after two digits

        setCardInfo({
            ...cardInfo,
            expiryDate: value,
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "cardHolder") {
            setIsCardHolderNameErr(false);
        }

        setCardInfo({
            ...cardInfo,
            [name]: value,
        });
    };

    const handleCVCChange = (e) => {
        setIsCardCVCErr(false);
        const newValue = e.target.value.replace(/\D/g, ""); // Remove non-digit characters
        setCardInfo({
            ...cardInfo,
            cvc: newValue,
        });
    };

    const handleInputFocus = (e) => {
        const { name } = e.target;
        setCardInfo({
            ...cardInfo,
            focus: name,
        });
    };

    const handleCardHolderNameBlurCheck = () => {
        if (cardInfo.cardHolder.trim() === "") {
            setIsCardHolderNameErr(true);
        }
    };

    const handleCardNumberBlurCheck = () => {
        // console.log(!validateCardNumber(Number(cardInfo.cardNumber)))
        // console.log(cardInfo.cardNumber, typeof cardInfo.cardNumber, 'handleCardNumberBlurCheck')

        const cardType = creditCardType(cardInfo.cardNumber);
        // console.log(cardType, 'cardType')

        if (
            cardInfo.cardNumber.length !== 16 ||
            cardType.length === 0
            // || !validator.isCreditCard(cardInfo.cardNumber)
        ) {
            setIsCardNumberErr(true);
        }
    };

    const handleCardExpBlurCheck = () => {
        const [month, year] = cardInfo.expiryDate.split("/");
        if (
            cardInfo.expiryDate.trim() === "" ||
            cardInfo.expiryDate.trim().length != 5 ||
            Number(month) > 12 ||
            Number(year) < Number(new Date().getFullYear().toString().slice(-2))
        ) {
            setIsCardExpErr(true);
        }
    };

    const handleCardCVCBlurCheck = () => {
        if (cardInfo.cvc.length < 3 || cardInfo.cvc.trim() === "") {
            setIsCardCVCErr(true);
        }
    };

    // New Payments methods functions starts here
    const [paymentGatewayFlag, setPaymentGatewayFlag] = useState(0);
    const [callChargeAmount, setCallChargeAmount] = useState(0);
    const [callDurationTimeLimit, setCallDurationTimeLimit] = useState(0);
    const [callChargeDescription, setCallChargeDescription] = useState("");
    const [toggleCardsMenu, setToggleCardsMenu] = useState(false);

    const getPaymentConfigFn = () => {
        let details = {};
        dispatch(
            getPaymentConfigApi(
                details,
                (res) => {
                    // console.log(res.data.data)
                    // console.log(res?.data?.data)
                    setPaymentGatewayFlag(
                        res?.data?.data?.purchase?.payment_gateway_flag
                    );
                    // setCallChargeAmount(
                    //     res?.data?.data?.purchase?.call_charge_amount_in_cents_int / 100
                    // );
                    setCallChargeAmount(
                        res?.data?.data?.purchase?.home_inspection_charge_amount_in_cents_int / 100
                    );
                    setCallDurationTimeLimit(
                        res?.data?.data?.purchase?.home_inspection_call_duration_time_limit_in_sec / 60
                    );
                    setCallChargeDescription(
                        res?.data?.data?.purchase?.home_inspection_description_chr
                    );
                },
                (res) => {
                    // console.log(res.data.data);
                }
            )
        );
    };

    // console.log(paymentGatewayFlag, 'paymentGatewayFlag', callChargeAmount, '$ callChargeAmount', callDurationTimeLimit, 'min callDurationTimeLimit')

    useEffect(() => {
        getPaymentConfigFn();
    }, []);

    useEffect(() => {
        setFinalAmountAfterPromoCodeApplied(callChargeAmount);
    }, [callChargeAmount])

    useEffect(() => {
        if (isCreditsUsed) {
            setFinalAmountAfterPromoCodeApplied(0);
        } else {
            setFinalAmountAfterPromoCodeApplied(callChargeAmount);
        }
        handleClearPromocodeStates();
    }, [isCreditsUsed])

    // Payment confirm modal functions
    const [paymentConfirmModal, setPaymentConfirmModal] = useState(false);
    const [isPaymentMethodErr, setIsPaymentMethodErr] = useState(false);
    const [primaryCardLoading, setPrimaryCardLoading] = useState(false);

    const handleOpenPaymentModalTrigger = (element) => {
        setPaymentConfirmModal(true);
        // setResponseBox(false);
        handleCloseInsectionConfirmationModal();
        // handleCloseDocScheduleModal();
        setScheduleModalTrigger(false);
    };

    const handleClosePaymentModalTrigger = () => {
        // setResponseBox(true);
        handleOpenInsectionConfirmationModal();
        setPaymentConfirmModal(false);
        handleClearPromocodeStates();
        setIsScheduledCall(false);
        setIsCreditsUsed(false);
    };

    const handleClearPromocodeStates = () => {
        setIsPromoCodeErr(false);
        setIsPaymentMethodErr(false);
        setPromoCode("");
        setVerifiedPromoCode("");
        // setFinalAmountAfterPromoCodeApplied(callChargeAmount);
    }

    // Check promocode functions
    const [promoCode, setPromoCode] = useState("");
    const [verifiedPromoCode, setVerifiedPromoCode] = useState("");
    const [isPromoCodeErr, setIsPromoCodeErr] = useState(false);
    const [promoCodeLoading, setPromoCodeLoading] = useState(false);
    const [finalAmountAfterPromoCodeApplied, setFinalAmountAfterPromoCodeApplied] = useState(0);

    // console.log(promoCode, 'promoCode')

    const handlePromoCode = (e) => {
        setIsPromoCodeErr(false);
        setIsPaymentMethodErr(false);
        setPromoCode(e.target.value);
    };

    const handlePromoCodeBlurCheck = () => {
        if (promoCode === "") {
            setIsPromoCodeErr(false);
        }
    };

    const handleCheckPromoCodeFn = () => {
        setPromoCodeLoading(true);

        let data = {
            promo_code_chr: promoCode,
            type_chr: "HOMEINSPECTION",
            user_id_ids: localStorage.getItem("user_id"),
            //  product_id_chr: productId,
        };
        dispatch(
            checkPromoCode(
                data,
                (res) => {
                    // console.log(res)
                    setVerifiedPromoCode(promoCode);

                    setFinalAmountAfterPromoCodeApplied(
                        res?.data?.data
                            ?.amount_to_be_charged_for_a_call_in_dollars_after_discount
                    );
                    // console.log(res?.data?.data?.amount_to_be_charged_for_a_subscription_in_dollars_after_discount, "final amoubt")
                    setIsPromoCodeErr(false);
                    setPromoCodeLoading(false);
                    setResponceMsg(res.data.message);
                    setToasterType("success");

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setIsPromoCodeErr(true);
                    setPromoCodeLoading(false);

                    setVerifiedPromoCode('');
                    setFinalAmountAfterPromoCodeApplied(callChargeAmount);
                    // setResponceMsg(res.data.message)
                    // setToasterType("error");

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                }
            )
        );
    };

    let USDollar = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });

    // Get payment method list functions
    const [supportedPaymentMethodsArr, setSupportedPaymentMethodsArr] = useState(
        []
    );
    const [
        customLoadingForSupportedMethods,
        setCustomLoadingForSupportedMethods,
    ] = useState(false);
    const [getSupportedPaymentFlag, setGetSupportedPaymentFlag] = useState(false);

    // Add new Payment method modal functions
    const [addNewPaymentMethodTrigger, setAddNewPaymentMethodTrigger] =
        useState(false);
    const handleCloseAddNewPaymentMethod = () => {
        setAddNewPaymentMethodTrigger(false);
        // handleClearCardStates();
    };
    const handleOpenAddNewPaymentMethod = () => {
        setAddNewPaymentMethodTrigger(true);
        // setGetSupportedPaymentFlag(true);
        // handleClosePaymentModalTrigger();
        getPaymentMethodSupportedListFn();
        setPaymentConfirmModal(false);
    };

    const getPaymentMethodSupportedListFn = () => {
        let details = {};
        setCustomLoadingForSupportedMethods(true);
        dispatch(
            getPaymentMethodSupportedList(
                details,
                (res) => {
                    // console.log(res.data.data)
                    // console.log(res?.data?.data)
                    setSupportedPaymentMethodsArr(res?.data?.data);
                    setCustomLoadingForSupportedMethods(false);
                },
                (res) => {
                    // console.log(res.data.data)
                    setCustomLoadingForSupportedMethods(false);
                }
            )
        );
    };

    useEffect(() => {
        if (getSupportedPaymentFlag) {
            getPaymentMethodSupportedListFn();
        }
    }, [getSupportedPaymentFlag]);

    // Add new card first time functions
    // Add new card modal functions
    const [formatedNumber, setFormatedNumber] = useState("");
    const [addCardFirstTimeTrigger, setAddCardFirstTimeTrigger] = useState(false);
    const handleCloseAddCardFirstTime = () => {
        setAddCardFirstTimeTrigger(false);
        handleClearCardStates();
        setPaymentConfirmModal(true);
    };
    const handleOpenAddCardFirstTime = () => {
        setAddCardFirstTimeTrigger(true);
    };

    const handleClearCardStates = () => {
        setCardInfo({
            cardNumber: "",
            expiryDate: "",
            cvc: "",
            cardHolder: "",
            focus: "",
        });
        setFormatedNumber("");
        setIsCardHolderNameErr(false);
        setIsCardNumberErr(false);
        setIsCardExpErr(false);
        setIsCardCVCErr(false);

        setCardCvcError('')
        setCardExpiryError('')
        setCardNumberError('')

        setZipCode('')
        setIsZipCodeErr(false)
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setApiResponse(true);
        const [month, year] = cardInfo.expiryDate.split("/");
        if (cardInfo.cardHolder.trim() === "") {
            setIsCardHolderNameErr(true);
            setApiResponse(false);
        }
        const cardType = creditCardType(cardInfo.cardNumber);

        if (
            cardInfo?.cardNumber?.length !== 16 ||
            cardType?.length === 0
            // || !validator.isCreditCard(cardInfo.cardNumber)
        ) {
            setIsCardNumberErr(true);
        }
        if (
            cardInfo.expiryDate.trim() === "" ||
            cardInfo?.expiryDate?.trim()?.length != 5 ||
            Number(month) > 12 ||
            Number(year) < Number(new Date().getFullYear().toString().slice(-2))
        ) {
            setIsCardExpErr(true);
            setApiResponse(false);
        }
        if (cardInfo?.cvc?.length < 3 || cardInfo?.cvc?.trim() === "") {
            setIsCardCVCErr(true);
            setApiResponse(false);
        }

        if (
            cardInfo?.cardHolder?.trim() === "" ||
            cardInfo?.cardNumber?.length !== 16 ||
            cardType?.length === 0 ||
            // !validator.isCreditCard(cardInfo.cardNumber) ||
            cardInfo.expiryDate.trim() === "" ||
            cardInfo?.expiryDate?.trim()?.length != 5 ||
            Number(month) > 12 ||
            Number(year) < Number(new Date().getFullYear().toString().slice(-2)) ||
            cardInfo?.cvc?.length < 3 ||
            cardInfo?.cvc?.trim() === ""
        ) {
            setApiResponse(false);
            return;
        }

        if (
            !isCardHolderNameErr &&
            !isCardNumberErr &&
            !isCardExpErr &&
            !isCardCVCErr
        ) {
            // Here you can handle the submission of the credit card information.

            let details = new FormData();

            details.append("user_id_ids", localStorage.getItem("user_id"));
            details.append("name_on_card", cardInfo.cardHolder);
            details.append("card_number", parseInt(cardInfo.cardNumber));
            details.append("expiry_month", parseInt(month));
            details.append("expiry_year", parseInt(year));
            details.append("card_cvc_number", parseInt(cardInfo.cvc));
            details.append("token_chr", "tok_visa");

            dispatch(
                createPaymentMethod(
                    details,
                    (res) => {
                        // console.log(res)
                        setApiResponse(false);
                        setResponceMsg(res.data.message);
                        setToasterType("success");
                        handleCloseAddCardFirstTime();

                        getPaymentMethodList(res?.data?.data?.customer?.id);

                        let details = {
                            user_id_ids: localStorage.getItem("user_id"),
                            role_id_int: localStorage.getItem("roleId"),
                            user_impersonate_flag: 0,
                        };
                        dispatch(
                            userById(details, (res) => {
                                dispatch(setUserDetails(res.data.data));
                            })
                        );

                        setPaymentConfirmModal(true);

                        // setHandleToaster(true);
                        // setTimeout(() => {
                        //     setHandleToaster(false);
                        // }, 11000);
                    },
                    (res) => {
                        // console.log(res)
                        setResponceMsg(res.data.message);
                        setToasterType("error");

                        setApiResponse(false);

                        setHandleToaster(true);
                        setTimeout(() => {
                            setHandleToaster(false);
                        }, 11000);
                    }
                )
            );
        }
    };

    const [cardArr, setCardArr] = useState([]);
    const [particularCard, setParticularCard] = useState({});

    // console.log(cardArr, "cardArr");

    const setInitialCardDetails = (res) => {
        res.data && setCardArr(res.data);
    };

    const handlePaymentConfirmation = () => {

        if (isCreditsUsed) {
            handleClearPromocodeStates();
            setPaymentConfirmModal(false);
            setIsCreditsUsed(false);

            if (isScheduledCall) {
                handleSubmitSchedule();
            } else {
                createServiceRequestFn();
            }

        } else {

            // Condition if paid subscritption and no promocode
            if (cardArr?.length == 0 && !verifiedPromoCode) {
                setIsPaymentMethodErr(true);
                return;
            }

            // Condition if paid subscritption and promocode with 100% discount
            if (
                cardArr?.length == 0 &&
                verifiedPromoCode &&
                finalAmountAfterPromoCodeApplied != 0
            ) {
                setIsPaymentMethodErr(true);
                return;
            }

            handleClearPromocodeStates();
            setPaymentConfirmModal(false);
            // submitFeedback();

            if (isScheduledCall) {
                handleSubmitSchedule();
            } else {
                createServiceRequestFn();
            }
        }
    };

    // Add new card modal functions
    const [addNewCardTrigger, setAddNewCardTrigger] = useState(false);
    const handleCloseAddNewCard = () => {
        setAddNewCardTrigger(false);
        getPaymentMethodList();
        setPaymentConfirmModal(true);
    };
    const handleOpenAddNewCard = () => {
        setAddNewCardTrigger(true);
    };

    // Set default payment method
    const selectPrimaryCardFn = (e, element) => {
        e.preventDefault();
        setPrimaryCardLoading(true);
        let details = new FormData();

        details.append("payment_method_id", element.id);
        details.append("user_id_ids", localStorage.getItem("user_id"));

        dispatch(
            setDefaultPaymentMethodById(
                details,
                (res) => {
                    // console.log(res)
                    setPrimaryCardLoading(false);
                    setResponceMsg(res.data.message);
                    setToasterType("success");

                    getPaymentMethodList();
                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {
                    // console.log(res)
                    setResponceMsg(res.data.message);
                    setToasterType("error");

                    setPrimaryCardLoading(false);

                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                }
            )
        );
    };

    useEffect(() => {
        if (customerID) {
            getPaymentMethodList();
        }
    }, []);

    useEffect(() => {
        if (!customerID) {
            const getCountryCode = async () => {
                try {
                    const response = await axios.get('https://ipapi.co/json/');
                    const data = response.data;
                    // console.log(`'My country code:', ${data.country}`)
                    setMyCountryCode(data.country);
                } catch (error) {
                    // console.log('Error fetching country code:', error);
                }
            };
            getCountryCode();
        }
    }, []);


    const getPaymentMethodList = (firstTimeID) => {
        let details = {
            customer_id_ids: customerID || firstTimeID,
        };
        dispatch(
            getPaymentMethodListByCustomerId(
                details,
                (res) => {
                    // console.log(res.data.data)
                    setInitialCardDetails(res?.data?.data);
                },
                (res) => {
                    // console.log(res.data.data)
                }
            )
        );
    };

    const stripe = useStripe();
    const elementsStripe = useElements();

    const handleSubmitStripe = async (event) => {
        event.preventDefault();
        setApiResponse(true);

        const isValidZipCode = validateZipCode();

        if (cardInfo.cardHolder.trim() === '' || !isValidZipCode) {
            if (cardInfo.cardHolder.trim() === '') {
                setIsCardHolderNameErr(true);
                setApiResponse(false);
            }

            if (zipCode.trim() === '') {
                setIsZipCodeErr(true);
                setApiResponse(false);
            }

        } else {
            if (!stripe || !elementsStripe) {
                // Ensure Stripe.js has loaded
                // console.log('Stripe has not loaded yet');
                setApiResponse(false);

                setResponceMsg('Stripe has not loaded yet')
                setToasterType("error");
                setHandleToaster(true);
                setTimeout(() => {
                    setHandleToaster(false);
                }, 2000);

                return;
            }

            // const cardElement = elements.getElement(CardElement);
            const cardElement = elementsStripe.getElement(CardNumberElement, {
                address_zip: zipCode,
            });


            // const cardNumberElement = elements.getElement(CardNumberInput);
            // const cardExpiryElement = elements.getElement(CardExpiryInput);
            // const cardCvcElement = elements.getElement(CardCvcInput);

            const { error, token } = await stripe.createToken(cardElement);

            if (error) {
                // console.log('Error:', error.message);
                setApiResponse(false);

                // setResponceMsg(error.message)
                // setToasterType("error");
                // setHandleToaster(true);
                // setTimeout(() => {
                //     setHandleToaster(false);
                // }, 2000);

            } else {
                // console.log('Success! Token: ', token);
                // console.log('Token created:', token.id);
                // You can now send the token to your server

                let details = new FormData();

                details.append("user_id_ids", localStorage.getItem("user_id"));
                details.append("name_on_card", cardInfo.cardHolder);
                details.append("token_chr", token.id);
                details.append("zip_code_chr", zipCode);
                details.append("country_code_chr", myCountryCode);

                setApiResponse(true);

                dispatch(
                    createPaymentMethod(
                        details,
                        (res) => {
                            // console.log(res)
                            setApiResponse(false);

                            setResponceMsg(res.data.message)
                            setToasterType("success")

                            handleCloseAddCardFirstTime();

                            getPaymentMethodList(res?.data?.data?.customer?.id);

                            let details = {
                                user_id_ids: localStorage.getItem('user_id'),
                                role_id_int: localStorage.getItem("roleId"),
                                user_impersonate_flag: 0
                            }
                            dispatch(
                                userById(details, (res) => {
                                    dispatch(setUserDetails(res.data.data));
                                }),
                            )

                            setPaymentConfirmModal(true);

                            // setHandleToaster(true);
                            // setTimeout(() => {
                            //     setHandleToaster(false);
                            // }, 11000);
                        },
                        (res) => {
                            // console.log(res)
                            setResponceMsg(res.data.message)
                            setToasterType("error");

                            setApiResponse(false);

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        }
                    )
                )
            }
        }



    }

    const [cardNumberError, setCardNumberError] = useState('');
    const [cardExpiryError, setCardExpiryError] = useState('');
    const [cardCvcError, setCardCvcError] = useState('');

    const handleCardNumberChangeStripe = (event) => {
        // setCardNumberError(event.error ? event.error.message : '');
        setCardNumberError(event.error ? 'Enter valid card number' : '');
    };

    const handleCardExpiryChangeStripe = (event) => {
        // setCardExpiryError(event.error ? event.error.message : '');
        setCardExpiryError(event.error ? 'Enter valid exp. date' : '');

    };

    const handleCardCvcChangeStripe = (event) => {
        // setCardCvcError(event.error ? event.error.message : '');
        setCardCvcError(event.error ? 'Enter valid cvc' : '');
    };


    const [zipCode, setZipCode] = useState("");
    const [isZipCodeErr, setIsZipCodeErr] = useState(false);
    const handleZipCode = (e) => {
        // setZipCode(e.target.value.replace(/\D/g, ''))
        setZipCode(e.target.value.replace(/\D/g, ''))
        setIsZipCodeErr(false)
    }

    const handleZipCodeBlurCheck = () => {
        // if (zipCode.trim() === '') {
        //     setIsZipCodeErr(true);
        // }

        validateZipCode();
    }

    const validateZipCode = () => {
        if (!zipCode) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        } else if (!isPostalCode(zipCode, myCountryCode || 'any')) {
            setIsZipCodeErr(true);
            setApiResponse(false);
            return false;
        }
        setIsZipCodeErr(false);
        return true;
    };


    // Scheduling start here ----------
    const [dateTime, setDateTime] = useState("");
    const [unixTimestamp, setUnixTimestamp] = useState("");
    const [unixEndTime, setUnixEndTime] = useState("");
    const [isDateTimeErr, setIsDateTimeErr] = useState(false);
    const [scheduleLoader, setScheduleLoader] = useState(false);

    const handleDateTime = (e) => {
        setIsDateTimeErr(false);
        const newDateTime = e.target.value;

        setDateTime(newDateTime);
        // console.log(e.target.value);

        // Convert the input value to a Unix timestamp
        const timestamp = new Date(newDateTime).getTime() / 1000;
        setUnixTimestamp(Math.floor(timestamp));
        // console.log(Math.floor(timestamp), "Start timestamp");

        // Calculate the end time by adding one hour (3600 seconds)
        const endTimeStamp = Math.floor(timestamp) + 3600;
        setUnixEndTime(endTimeStamp);
        // console.log(endTimeStamp, "End timestamp");
    };

    // Modal functions for the date time confirmation
    const [scheduleModalTrigger, setScheduleModalTrigger] = React.useState(false);
    const handleOpenScheduleModal = () => {
        setScheduleModalTrigger(true);
        handleCloseInsectionConfirmationModal()
    };

    const handleCloseDocScheduleModal = () => {
        setScheduleModalTrigger(false);
        setIsDateTimeErr(false);
        handleClearSchedule();
        handleOpenInsectionConfirmationModal();
    };

    const handleClearSchedule = () => {
        setDateTime("");
        setUnixTimestamp("");
        setUnixEndTime("");
    };

    // New functions for the Schedule call
    const [currentDate, setCurrentDate] = useState("");
    const [currentTime, setCurrentTime] = useState("");

    useEffect(() => {
        handleSetCurrentDateAndTime();
    }, []);

    // const handleSetCurrentDateAndTime = () => {
    //     // Get the current date and time
    //     const now = new Date();
    //     const date = now.toISOString().split("T")[0]; // format yyyy-mm-dd for the date input

    //     // Set the time one hour ahead, format hh:mm for the time input
    //     now.setHours(now.getHours() + 1);
    //     let hours = now.getHours();
    //     let minutes = now.getMinutes();
    //     // Ensure two-digit formatting for hours and minutes
    //     hours = hours < 10 ? `0${hours}` : hours;
    //     minutes = minutes < 10 ? `0${minutes}` : minutes;
    //     const time = `${hours}:${minutes}`;

    //     // Update the state
    //     setCurrentDate(date);
    //     setCurrentTime(time);
    // };

    const handleSetCurrentDateAndTime = () => {
        // Get the current date and time
        const now = new Date();
        const date = now.toISOString().split('T')[0]; // format yyyy-mm-dd for the date input

        // Set the time one hour ahead
        now.setHours(now.getHours() + 1);

        let hours = now.getHours();
        let minutes = now.getMinutes();

        // Adjust minutes to the nearest 30-minute slot
        minutes = minutes < 30 ? 0 : 30;

        // If minutes round up to 0 and it causes the hour to increase (e.g., 23:59 -> 00:00)
        if (minutes === 0 && now.getMinutes() >= 30) {
            hours += 1;
        }

        // Ensure two-digit formatting for hours and minutes
        hours = hours < 10 ? `0${hours}` : hours;
        minutes = minutes === 0 ? `00` : `30`;

        const time = `${hours}:${minutes}`;

        // Update the state
        setCurrentDate(date);
        setCurrentTime(time);
    };

    const handleTimeChange = (e) => {
        const value = e.target.value;
        const [hours, minutes] = value.split(':').map(Number);

        // Adjust minutes to nearest valid option (0 or 30)
        const validMinutes = minutes < 15 ? '00' : '30';

        const correctedTime = `${hours.toString().padStart(2, '0')}:${validMinutes}`;
        setCurrentTime(correctedTime);
    };

    // console.log(currentDate, "Date");
    // console.log(currentTime, "Time");

    const convertToUnixTime = () => {
        // Combine the date and time into a single Date object
        const combinedDateTime = new Date(`${currentDate}T${currentTime}`);
        // Convert to Unix timestamp
        return Math.floor(combinedDateTime.getTime() / 1000);
    };

    const calculateEndTime = (unixTime) => {
        // Adding 3600 seconds (1 hour) to the current unix timestamp
        return unixTime + 3600;
    };

    const handleSubmitSchedule = () => {
        // console.log(dateTime, unixTimestamp, unixEndTime);
        setScheduleLoader(true);

        const startTimeUnix = convertToUnixTime();
        const endTimeUnix = calculateEndTime(startTimeUnix);

        let createTicketData = new FormData();

        createTicketData.append("user_id_ids", localStorage.getItem("user_id"));
        // createTicketData.append("address_id_ids",0)
        //  !predictionFlag && productNameForTicket && createTicketData.append("object_name_chr",productNameForTicket)
        // createTicketData.append("object_name_chr", productNameForTicket ? productNameForTicket : predictedObjectClassName);
        inventoryType && createTicketData.append("object_name_chr", inventoryType);
        createTicketData.append("object_category_chr", categoryName || "Inspection");
        inventoryModel && createTicketData.append("object_model_number_chr", inventoryModel);
        inventoryDesc && createTicketData.append("problem_description_chr", inventoryDesc);
        inventoryBrand && createTicketData.append("device_brand_chr", inventoryBrand);
        // deviceColorChr && createTicketData.append("device_color_chr", deviceColorChr);
        // inventoryImage && createTicketData.append("attachment0", inventoryImage, "uploadAttachedImage0.jpeg");
        // uploadAttachedImage1 != null && createTicketData.append("attachment1", uploadAttachedImage1, "uploadAttachedImage1.jpeg");
        // uploadAttachedImage2 != null && createTicketData.append("attachment2", uploadAttachedImage2, "uploadAttachedImage2.jpeg");
        // verifiedPromoCode && createTicketData.append("amount_after_discount", finalAmountAfterPromoCodeApplied);
        homeAreaProductId && createTicketData.append("home_area_product_id_ids", homeAreaProductId);
        createTicketData.append(
            "amount_after_discount",
            finalAmountAfterPromoCodeApplied
        );

        isCreditsUsed && createTicketData.append("use_credits_flag", isCreditsUsed);

        verifiedPromoCode && createTicketData.append("promo_code_applied", verifiedPromoCode);

        createTicketData.append("is_scheduling_flag", 1);
        createTicketData.append("unix_datetime_stamp_start", startTimeUnix);
        createTicketData.append("unix_datetime_stamp_end", endTimeUnix);

        dispatch(
            CreateTicket(
                createTicketData,
                (res) => {
                    // localStorage.setItem("triggerFlag", 1);
                    // localStorage.setItem("roomCode", res.data.data.room_id);
                    // localStorage.setItem("call_log_id",res.data.data.room_id)
                    // navigate("/videoCall")
                    // console.log(res)
                    setScheduleModalTrigger(false);

                    handleOpenScheduleSuccess();


                    localStorage.setItem("ticket_id", res.data.data.ticket_id_ids);
                    localStorage.setItem("proType", res.data.data.product_type_chr);
                    setScheduleLoader(false);

                    setResponceMsg(res.data.message);
                    setToasterType("success");
                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (err) => {
                    // console.log(err)

                    setScheduleLoader(false);

                    setResponceMsg(err.data.message);
                    setToasterType("error");
                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);

                }
            )
        );
    };

    // New calendar functions start here
    const [selectedDate, setSelectedDate] = useState(new Date()); // Initialize with current date or null

    const handleDateChange = (date) => {
        // Format the date when it is selected and log it or use it as needed
        const formattedDate = format(date, "yyyy-MM-dd");
        // console.log(formattedDate, "Formated date"); // Outputs the date in "2024-04-24" format
        setCurrentDate(formattedDate);
        setSelectedDate(date);
    };

    // console.log(currentDate, "Date current");
    // console.log(selectedDate, "selectDate here");
    const today = new Date();

    // Scheduling ends here -----------

    // Response modal after scheduling service request
    const [responseScheduleSuccess, setResponseScheduleSuccess] = useState(false);
    const handleOpenScheduleSuccess = () => {
        setResponseScheduleSuccess(true);
    };
    const handleCloseScheduleSuccess = () => {
        setResponseScheduleSuccess(false);
        navigate("/serviceRequest");
    };




    return (
        <>
            {toggleForMaintenance == 1 ?
                <div className="row d-flex justify-content-center align-items-center">
                    <div className="col mx-3 align-items-center">

                        <div className="row mx-0">
                            <div className="col-md-3 col-sm-12"></div>
                            <div className="col-md-6 col-sm-12 px-3">
                                <div>
                                    <div className="row mx-0">
                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                            <span className="fs-5 font-w600 text-center">
                                                {'A check-up helps you maintain your home inventory and avoid costly future repairs'}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row mx-0 my-3">
                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                            <img src={houseImg} alt="logo" style={{ height: '90px', width: '90px' }} />
                                        </div>
                                    </div>

                                    <div className="row mx-0 mb-3">
                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center">
                                            <span className="fs-5 font-w700 text-center text-black">
                                                {'What would you like to do now?'}
                                            </span>
                                        </div>
                                    </div>

                                    {!inspectionLoading ?
                                        <>
                                            {itemListCount > 0 &&
                                                <div className="row mx-0 mb-2 ">
                                                    <div
                                                        className="col-12 p-3 bg-white rounded-2 shadow-lg cursor-pointer d-flex"
                                                        onClick={() => navigate('/checkUpResults')}
                                                    >
                                                        <div className="mx-3">
                                                            <img src={checkUpResultImg} alt="logo" style={{ height: '60px', width: '60px' }} />
                                                        </div>
                                                        <div className="d-flex  flex-column">
                                                            <span className="fs-5 font-w600 text-black">
                                                                {`View check-up results`}
                                                            </span>

                                                            <span className="fs-7 font-w500">
                                                                {`You can review your current item conditions at any time`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            }

                                            <div className="row mx-0 mb-2 ">
                                                <div
                                                    className="col-12 p-3 bg-white rounded-2 shadow-lg cursor-pointer d-flex"
                                                    onClick={() => {
                                                        // createServiceRequestFn()
                                                        handleOpenInsectionConfirmationModal();
                                                    }}
                                                >
                                                    <div className="mx-3">
                                                        <img src={proInspectorImg} alt="logo" style={{ height: '60px', width: '60px' }} />
                                                    </div>
                                                    <div className="d-flex  flex-column">
                                                        <span className="fs-5 font-w600 text-black">
                                                            {`Conduct a home check-up with a Chilll Pro`}
                                                        </span>

                                                        <span className="fs-7 font-w500">
                                                            {`Pro guides you through each step, collecting info, item condition and recommended maintenance tasks`}
                                                        </span>

                                                        <div className="w-100 mt-2 d-flex justify-content-between align-items-center fs-7">
                                                            <div className="px-2 py-1 rounded-pill text-white"
                                                                style={{ background: 'linear-gradient(142.98deg, #16BA4E 1.99%, #19DF5C 99.97%)' }}
                                                            >
                                                                <span>{`Recommended`}</span>
                                                            </div>

                                                            <div>
                                                                {callChargeAmount > 0 && <>
                                                                    <span>{`Price: `}</span>
                                                                    <span className="font-w600">
                                                                        {`${USDollar.format(
                                                                            parseFloat(callChargeAmount?.toFixed(2))
                                                                        )}`}
                                                                    </span>
                                                                </>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mx-0 mb-2 ">
                                                <div
                                                    className="col-12 p-3 bg-white rounded-2 shadow-lg cursor-pointer d-flex"
                                                    onClick={() => setToggleForMaintenance(2)}
                                                >
                                                    <div className="mx-3">
                                                        <img src={customerImg} alt="logo" style={{ height: '60px', width: '60px' }} />
                                                    </div>
                                                    <div className="d-flex flex-column">
                                                        <span className="fs-5 font-w600 text-black">
                                                            {`Conduct a home check-up myself`}
                                                        </span>

                                                        <span className="fs-7 font-w500">
                                                            {`You will go through each step yourself`}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="row mx-0 mb-2">
                                                <SkeletonDivElement
                                                    height={"60px"}
                                                    rows={3}
                                                    borderRadius={'7px'}
                                                    marginBottom={'5px'}
                                                />
                                            </div>
                                        </>}
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-12"></div>
                        </div>
                    </div>
                </div>
                :
                toggleForMaintenance == 2 ?
                    <div className="row d-flex justify-content-center align-items-center">
                        <div className="col mx-3 align-items-center">

                            <div className="row mx-0">
                                <div className='col-12 d-flex'>
                                    <div onClick={() => { setToggleForMaintenance(1); handleClearInventoryStates() }} className='overlay-action-btn text-hovered py-1 pe-3 fs-5 font-w500 cursor-pointer rounded-1 mb-1 d-flex align-items-center'>
                                        <i class="bi bi-arrow-left-short pe-2"></i>
                                        <span>{"Back"}</span>
                                    </div>
                                </div>
                            </div>

                            <div className="row mt-2">
                                <div
                                    className="row w-100 mx-0 mb-3 shadow-lg"
                                    style={{
                                        backgroundColor: "rgba(251, 252, 255, 1)",
                                        borderRadius: '16px'
                                    }}
                                >
                                    <div className="col-lg-12 px-0 mt-2 ">
                                        <div className="mx-0 row">
                                            <div className="col-12 px-0">
                                                <div
                                                    className="w-100 h-100  "

                                                >
                                                    <div className="col-12 mb-2 p-2 h-100">
                                                        <div className="row mx-0 h-100">
                                                            <div className="align-items-center col-12 col-md-3 col-sm-4 d-flex  justify-content-center ">
                                                                <div
                                                                    className="align-items-cente bg-white d-flex fs-2 justify-content-center text-black"
                                                                    style={{ height: "90px", width: "90px" }}
                                                                >
                                                                    <img src={houseImg} alt="logo" style={{ height: '90px', width: '90px' }} />
                                                                    {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                                                                </div>
                                                            </div>

                                                            <div className="col-12 col-md-9 col-sm-8 d-flex align-items-center justify-content-start justify-md-content-center">
                                                                <>
                                                                    <div className="d-flex flex-column">
                                                                        <span className="fs-4 font-w800 text-black mb-2">
                                                                            {`Home maintenance`}
                                                                        </span>
                                                                        <div className="mb-2">
                                                                            <span className="fs-6 font-w600 text-black">
                                                                                {`No Check-Up `}
                                                                            </span>
                                                                            <span className="fs-6 ">
                                                                                {`conducted yet`}
                                                                            </span>
                                                                        </div>

                                                                        <div
                                                                            style={{
                                                                                // pointerEvents: 'none',
                                                                                // opacity: '0.5',
                                                                            }}
                                                                        >
                                                                            <PrimaryButton
                                                                                buttonName={`REQUEST VIRTUAL CHECK-UP`}
                                                                                onClick={() => {
                                                                                    // createServiceRequestFn()
                                                                                    handleOpenInsectionConfirmationModal();
                                                                                }}
                                                                                style={{
                                                                                    width: '330px',
                                                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mx-1 border-top mt-2 border-light">
                                            <div
                                                className="align-items-center col-12 cursor-pointer d-flex font-w700 fs-6 justify-content-center mb-1 overlay-action-btn p-3 rounded-bottom text-hovered w-100"
                                                onClick={() => handleOpenMaintenanceInfoModal()}
                                                style={{
                                                    backgroundColor: "rgba(244, 248, 255, 1)",
                                                }}
                                            >

                                                <span className="me-2">
                                                    <i className="bi bi-info-circle"></i>
                                                </span>
                                                <span>{`Why you want a home check-up`}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="row px-0 my-2"
                            >
                                <div
                                    className="row mx-0  align-items-center py-3 shadow-lg"
                                    style={{
                                        backgroundColor: "rgba(251, 252, 255, 1)",
                                        borderRadius: '16px',
                                    }}
                                >
                                    <div className="col-12 d-flex fs-5 font-w600">
                                        <div className="me-4 ms-3 text-black">
                                            <span>{`My rooms : `}</span>
                                            <span>{`${myRooms.length}`}</span>
                                        </div>

                                        <div
                                            className="me-4 cursor-pointer text-hovered"
                                            style={{
                                                pointerEvents: itemListCount > 0 ? 'auto' : 'none',
                                                opacity: itemListCount > 0 ? '1' : '0.5',
                                            }}
                                            onClick={() => navigate('/checkUpResults')}
                                        >
                                            <span className="me-2">{`View report`}</span>
                                            <span>
                                                <i className="bi bi-file-text"></i>
                                            </span>
                                        </div>

                                        <div
                                            className="me-4 cursor-pointer text-hovered"
                                            onClick={() => { handleOpenRoomModal(1) }}
                                        >
                                            <span className="me-2">{`Define room list`}</span>
                                            <span>
                                                <i className="bi bi-pencil"></i>
                                            </span>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/* <hr /> */}

                            {myRooms.length > 0 ?
                                <>
                                    {myRooms.map((element, index) => {
                                        return (
                                            <div
                                                key={index}
                                                className="row  px-0 my-2 cursor-pointer "
                                                onClick={() => {
                                                    if (element?.area_id_ids === isExpandedItem) {
                                                        setIsExpandedItem('')
                                                    } else {
                                                        setIsExpandedItem(element.area_id_ids)
                                                    }
                                                    setAreaId(element.area_id_ids);
                                                    setActivePopover(null);
                                                    setIsExpandedForAddMaintenance('');
                                                    clearMaintenancePlanStates();
                                                    setIsExpandedForMaintenancePlan('');
                                                    setIsExpandedForProduct('');
                                                }}
                                            >
                                                <div
                                                    className="row px-3 py-3 shadow-lg"
                                                    style={{
                                                        backgroundColor: "rgba(251, 252, 255, 1)",
                                                        borderRadius: '16px',
                                                    }}
                                                >
                                                    <div className={`col-12 d-flex fs-5 font-w600 ${element.area_id_ids === isExpandedItem && 'mb-3'} `}>
                                                        <div className="d-flex align-items-center justify-content-between w-100">
                                                            <div className="me-4 text-black d-flex align-items-center justify-content-center">
                                                                {/* <span
                                                                    className="me-2 p-2 border rounded bg-dark shadow-lg text-white"
                                                                >
                                                                    <i
                                                                        class="bi bi-cloud-hail-fill"
                                                                        style={{ height: '20px', width: '20px' }}
                                                                    ></i>
                                                                </span> */}

                                                                <div
                                                                    className="me-2 rounded d-flex align-items-center justify-content-center border"
                                                                    style={{ background: 'rgba(79, 93, 116, 1)', width: '30px', height: '30px' }}
                                                                >
                                                                    <img
                                                                        src={element?.ref_icon_url}
                                                                        alt=""
                                                                        className="rounded border"
                                                                        style={{ width: "30px", height: "30px", background: 'rgba(79, 93, 116, 1)' }}
                                                                    />
                                                                </div>

                                                                <span>{`${element.display_area_name_chr}`}</span>
                                                            </div>

                                                            <div className="text-black d-flex align-items-center">
                                                                {element?.item_count ?
                                                                    <span
                                                                        className="px-2 py-1 fs-7 text-white rounded-circle d-flex align-items-center justify-content-center font-w500 me-2 shadow"
                                                                        style={{
                                                                            background: 'rgba(131, 154, 192, 1)',
                                                                        }}
                                                                    >
                                                                        {`${element?.item_count}`}
                                                                    </span> : ''
                                                                }

                                                                <span>
                                                                    {element.area_id_ids === isExpandedItem ?
                                                                        <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i> :
                                                                        <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i>
                                                                    }
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {element.area_id_ids === isExpandedItem &&
                                                        <>
                                                            <div className="row px-0">
                                                                <div className="col-12" style={{ height: '' }}>

                                                                    {element?.item_list?.map((item, ind) => {
                                                                        return (
                                                                            <>
                                                                                <div
                                                                                    key={ind}
                                                                                    className="row mx-0 "
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                    }}
                                                                                    style={{ cursor: 'default' }}
                                                                                >
                                                                                    <div
                                                                                        className="col-12 px-3 border-top"
                                                                                        style={{
                                                                                            background: 'rgb(199 212 234 / 30%)',
                                                                                        }}
                                                                                    >
                                                                                        <div
                                                                                            className="d-flex align-items-center justify-content-between w-100 py-3 font-w600 cursor-pointer text-black text-hovered"
                                                                                            onClick={() => {
                                                                                                if (item?.home_area_product_id_ids === isExpandedForProduct) {
                                                                                                    setIsExpandedForProduct('')
                                                                                                } else {
                                                                                                    setIsExpandedForProduct(item?.home_area_product_id_ids)
                                                                                                }
                                                                                            }}
                                                                                        >
                                                                                            <div className="me-4 d-flex">
                                                                                                <div className='me-3 position-relative'>
                                                                                                    <div className='position-absolute'
                                                                                                        style={{
                                                                                                            top: '-10px',
                                                                                                            right: '-9px',
                                                                                                        }}
                                                                                                    >
                                                                                                        {
                                                                                                            item?.condition_chr === "Good" ?
                                                                                                                <IoCheckmarkCircleOutline
                                                                                                                    style={{ height: '18px', width: '18px', color: 'rgba(45, 204, 99, 1)' }}
                                                                                                                    className='bg-white rounded-circle shadow'
                                                                                                                /> :
                                                                                                                item?.condition_chr === "Ok" ?
                                                                                                                    <TiSpanner
                                                                                                                        style={{ height: '18px', width: '18px', color: 'rgba(255, 154, 32, 1)', border: '1px solid rgba(255, 154, 32, 1)' }}
                                                                                                                        className='bg-white rounded-circle shadow'
                                                                                                                    /> :
                                                                                                                    item?.condition_chr === "Poor" ?
                                                                                                                        <MdOutlineCancel
                                                                                                                            style={{ height: '18px', width: '18px', color: 'rgba(240, 72, 72, 1)' }}
                                                                                                                            className='bg-white rounded-circle shadow'
                                                                                                                        /> : ''
                                                                                                        }
                                                                                                    </div>

                                                                                                    {item?.image_url ?
                                                                                                        <div
                                                                                                            className="me-2 rounded d-flex align-items-center justify-content-center border shadow-lg"
                                                                                                            style={{ background: 'rgba(79, 93, 116, 1)', width: '25px', height: '25px' }}
                                                                                                        >
                                                                                                            <img
                                                                                                                // src={element?.ref_icon_url}
                                                                                                                src={item?.image_url}
                                                                                                                alt=""
                                                                                                                className="rounded border"
                                                                                                                style={{ width: "25px", height: "25px", background: 'rgba(79, 93, 116, 1)' }}
                                                                                                            />
                                                                                                        </div> :
                                                                                                        <span
                                                                                                            className=" p-2 rounded bg-white shadow-lg text-black"
                                                                                                        >
                                                                                                            <i
                                                                                                                class="bi bi-cloud-hail-fill"
                                                                                                                style={{ height: '25px', width: '25px' }}
                                                                                                            ></i>
                                                                                                        </span>
                                                                                                    }
                                                                                                </div>

                                                                                                <span>{`${item?.product_name_chr}`}</span>
                                                                                            </div>

                                                                                            <div
                                                                                                className="text-black fs-4 text-hovered overlay-action-btn rounded-circle d-flex align-items-center justify-content-center cursor-pointer"
                                                                                            >
                                                                                                <span>
                                                                                                    <span>
                                                                                                        <OverlayTrigger
                                                                                                            key={ind}
                                                                                                            trigger="click"
                                                                                                            placement="bottom"
                                                                                                            // overlay={popover}
                                                                                                            overlay={popover(ind)}
                                                                                                            rootClose={true}
                                                                                                            show={activePopover === ind}
                                                                                                            onToggle={(show) => setActivePopover(show ? ind : null)}
                                                                                                        >
                                                                                                            <i onClick={(e) => { e.stopPropagation(); handleMenuClick(item, ind) }} class="bi bi-three-dots-vertical px-1"></i>
                                                                                                        </OverlayTrigger>
                                                                                                    </span>
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>

                                                                                        {item?.home_area_product_id_ids === isExpandedForProduct &&
                                                                                            <div className="row mb-2 bg-white rounded-2 shadow-sm">
                                                                                                <div className="col-12 p-1">
                                                                                                    <div className="row mx-1 pb-1 pt-2 px-3 d-flex align-items-center">
                                                                                                        <div className="col-4 pe-2  font-w500">
                                                                                                            <span>{`Condition`}</span>
                                                                                                        </div>
                                                                                                        <div className="col-8 d-flex">
                                                                                                            <span
                                                                                                                className="text-white rounded-pill p-1 px-3"
                                                                                                                style={{
                                                                                                                    background:
                                                                                                                        `${item?.condition_chr === "Good" ? "rgba(45, 204, 99, 1)" :
                                                                                                                            item?.condition_chr === "Ok" ? "rgba(255, 154, 32, 1)" :
                                                                                                                                item?.condition_chr === "Poor" ? "rgba(240, 72, 72, 1)" :
                                                                                                                                    item?.condition_chr === "Not assessed" ? "rgba(131, 154, 192, 1)" : ''}`,
                                                                                                                }}
                                                                                                            >
                                                                                                                {`${item?.condition_chr}`}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="row mx-1 py-2 px-3 border-bottom  d-flex align-items-center">
                                                                                                        <div className="col-4 pe-2  font-w500">
                                                                                                            <span>{`Updated`}</span>
                                                                                                        </div>
                                                                                                        <div className="col-8">
                                                                                                            <span className="text-black font-w600 p-1 px-2">{`${formatUnixTimestamp(item?.updated_date_dtm)}`}</span>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                            <span>{`Brand`}</span>
                                                                                                        </div>
                                                                                                        <div className="col-8">
                                                                                                            <span className={`${item?.device_brand_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.device_brand_chr ? item?.device_brand_chr : '-'}`}</span>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                            <span>{`Model`}</span>
                                                                                                        </div>
                                                                                                        <div className="col-8">
                                                                                                            <span className={`${item?.model_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.model_number_chr ? item?.model_number_chr : '-'}`}</span>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                            <span>{`Serial number`}</span>
                                                                                                        </div>
                                                                                                        <div className="col-8">
                                                                                                            <span className={`${item?.serial_number_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.serial_number_chr ? item?.serial_number_chr : '-'}`}</span>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                            <span>{`Description`}</span>
                                                                                                        </div>
                                                                                                        <div className="col-8">
                                                                                                            <span className={`${item?.description_chr && 'text-black'} font-w600 p-1 px-2`}>{`${item?.description_chr ? item?.description_chr : '-'}`}</span>
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    {item?.image_urls?.length > 0 &&
                                                                                                        <div className="row mx-1 py-2 px-3 d-flex align-items-center">
                                                                                                            <div className="col-12 overflow-auto">
                                                                                                                {item?.image_urls?.map((data, i) => (
                                                                                                                    <img
                                                                                                                        key={i}
                                                                                                                        src={data}
                                                                                                                        alt="Attachment"
                                                                                                                        className="rounded-2 shadow-lg cursor-pointer me-2"
                                                                                                                        onClick={(e) => {
                                                                                                                            handleOpenDoc(); setImageAttachURL(data);
                                                                                                                        }}
                                                                                                                        style={{
                                                                                                                            height: '60px',
                                                                                                                            width: '60px',
                                                                                                                            border: '1px solid orange'
                                                                                                                        }}
                                                                                                                    />
                                                                                                                ))}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    }

                                                                                                    {item?.maintenance_plan?.length > 0 &&
                                                                                                        <div
                                                                                                            className="row mx-0 py-2 font-w700 d-flex border-top"
                                                                                                            style={{
                                                                                                                background: 'rgb(199 212 234 / 30%)',
                                                                                                                // pointerEvents: 'none',
                                                                                                                // opacity: '0.5',
                                                                                                            }}
                                                                                                        >
                                                                                                            {item?.maintenance_plan?.map((data, i) => {
                                                                                                                return (
                                                                                                                    <div
                                                                                                                        className={`bg-white mb-1 ${data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan && 'shadow'} rounded `}
                                                                                                                        style={{ margin: '0' }}
                                                                                                                    >
                                                                                                                        <div
                                                                                                                            className="row mx-1  py-2 px-3 d-flex align-items-center"
                                                                                                                        >
                                                                                                                            <div
                                                                                                                                className="row mx-0  cursor-pointer"
                                                                                                                                onClick={() => {
                                                                                                                                    if (data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan) {
                                                                                                                                        setIsExpandedForMaintenancePlan('')
                                                                                                                                    } else {
                                                                                                                                        setIsExpandedForMaintenancePlan(data.maintenance_plan_id_ids)
                                                                                                                                    }
                                                                                                                                }}
                                                                                                                            >
                                                                                                                                <div className="col-4 pe-2 font-w500">
                                                                                                                                    <span>{`Maintenance`}</span>
                                                                                                                                </div>
                                                                                                                                <div className="col-8 d-flex align-items-center justify-content-between">
                                                                                                                                    <span className={`${data?.instruction_chr && 'text-black'} font-w600 p-1 px-2`}>{`${data?.instruction_chr ? `${data?.instruction_chr}` : '-'}`}</span>

                                                                                                                                    <span>
                                                                                                                                        {data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan ?
                                                                                                                                            <i class="bi bi-chevron-up ms-2 border rounded px-1 "></i> :
                                                                                                                                            <i class="bi bi-chevron-down ms-2 border rounded px-1 "></i>
                                                                                                                                        }
                                                                                                                                    </span>
                                                                                                                                </div>
                                                                                                                            </div>

                                                                                                                            {data?.maintenance_plan_id_ids === isExpandedForMaintenancePlan &&
                                                                                                                                <>
                                                                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                                                            <span>{`When`}</span>
                                                                                                                                        </div>
                                                                                                                                        <div className="col-8">
                                                                                                                                            <span className={`${data?.period_name_chr && 'text-black'} font-w600 p-1 px-2`}>{`${data?.period_name_chr ? `In ${data?.period_name_chr}` : '-'}`}</span>
                                                                                                                                        </div>
                                                                                                                                    </div>

                                                                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                                                            <span>{`Frequency`}</span>
                                                                                                                                        </div>
                                                                                                                                        <div className="col-8">
                                                                                                                                            <span className={`${data?.frequency_int && 'text-black'} font-w600 p-1 px-2`}>{`${data?.frequency_int ? `${data?.frequency_int} times in a ${data?.period_name_chr}` : '-'}`}</span>
                                                                                                                                        </div>
                                                                                                                                    </div>


                                                                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                                                                        <div className="col-4 pe-2 font-w500">
                                                                                                                                            <span>{`Link`}</span>
                                                                                                                                        </div>
                                                                                                                                        <div className="col-8">
                                                                                                                                            {data?.purchase_link ?
                                                                                                                                                <a
                                                                                                                                                    className="text-hovered text-gray-800"
                                                                                                                                                    href={`${data?.purchase_link}`}
                                                                                                                                                    target="_blank"
                                                                                                                                                    rel="noreferrer"
                                                                                                                                                >
                                                                                                                                                    <span className={`font-w600 p-1 px-2`}>{`Purchase link`} <i className="bi bi-chevron-right me-2"></i> </span>
                                                                                                                                                </a> :
                                                                                                                                                <span className={`font-w600 p-1 px-2`}>{`-`} </span>
                                                                                                                                            }
                                                                                                                                        </div>
                                                                                                                                    </div>

                                                                                                                                    <div className="row mx-1 py-2  d-flex align-items-center">
                                                                                                                                        <div className="col-12">
                                                                                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                                                                                <div className="mx-2"></div>
                                                                                                                                                <div className="mx-2 d-flex align-items-center fs-4">

                                                                                                                                                    <div className="me-2">
                                                                                                                                                        <div className="tooltipCustom">
                                                                                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Edit"}</span>
                                                                                                                                                            <span
                                                                                                                                                                className="cursor-pointer overlay-action-btn px-2 py-1 rounded-2 text-gray-800 text-hovered"
                                                                                                                                                                onClick={() => {
                                                                                                                                                                    updateMaitenancePlanFn(data);
                                                                                                                                                                    setIsExpandedForAddMaintenance('');
                                                                                                                                                                }}
                                                                                                                                                            >
                                                                                                                                                                <i className="bi bi-pencil"></i>
                                                                                                                                                            </span>
                                                                                                                                                        </div>
                                                                                                                                                    </div>

                                                                                                                                                    <div className="me-2">
                                                                                                                                                        <div className="tooltipCustom">
                                                                                                                                                            <span className="tooltiptextCustom w-100" style={{ minWidth: 'max-content' }}>{"Delete"}</span>
                                                                                                                                                            <span
                                                                                                                                                                className="cursor-pointer overlay-action-btn px-2 py-1 rounded-2 text-gray-800 text-hovered"
                                                                                                                                                                onClick={() => {
                                                                                                                                                                    handleOpenMaintenancePlanModal(2);
                                                                                                                                                                    setMaintenancePlanId(data?.maintenance_plan_id_ids);
                                                                                                                                                                    setInstruction(data?.instruction_chr);
                                                                                                                                                                }}
                                                                                                                                                            >
                                                                                                                                                                <i className="bi bi-trash"></i>
                                                                                                                                                            </span>
                                                                                                                                                        </div>
                                                                                                                                                    </div>
                                                                                                                                                </div>
                                                                                                                                            </div>

                                                                                                                                        </div>
                                                                                                                                    </div>

                                                                                                                                </>
                                                                                                                            }

                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                )
                                                                                                            })}
                                                                                                        </div>
                                                                                                    }

                                                                                                    <div
                                                                                                        className="row mx-0 py-2 font-w700 d-flex align-items-center border-top border-bottom cursor-pointer text-hovered overlay-action-btn"
                                                                                                        style={{
                                                                                                            background: 'rgb(199 212 234 / 30%)',
                                                                                                            // pointerEvents: 'none',
                                                                                                            // opacity: '0.5',
                                                                                                        }}
                                                                                                        onClick={() => {
                                                                                                            if (item?.home_area_product_id_ids === isExpandedForAddMaintenance) {
                                                                                                                setIsExpandedForAddMaintenance('')
                                                                                                            } else {
                                                                                                                setIsExpandedForAddMaintenance(item.home_area_product_id_ids)
                                                                                                                clearMaintenancePlanStates();
                                                                                                            }
                                                                                                            setHomeAreaProductId(item?.home_area_product_id_ids);
                                                                                                        }}
                                                                                                    >
                                                                                                        <div
                                                                                                            className={`col-12 d-flex ${item?.home_area_product_id_ids === isExpandedForAddMaintenance ? 'justify-content-around' : 'justify-content-center'} align-items-center`}>
                                                                                                            <div>
                                                                                                                <span>{`Add maintenance plan`}</span>
                                                                                                                <span>
                                                                                                                    <i className="bi bi-plus-circle ms-2"></i>
                                                                                                                </span>
                                                                                                            </div>

                                                                                                            {item?.home_area_product_id_ids === isExpandedForAddMaintenance &&
                                                                                                                <div
                                                                                                                    onClick={(e) => {
                                                                                                                        e.stopPropagation();
                                                                                                                        setIsExpandedForAddMaintenance('');
                                                                                                                        setHomeAreaProductId("");
                                                                                                                        clearMaintenancePlanStates();
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <i className="bi bi-x-lg ms-2"></i>
                                                                                                                </div>
                                                                                                            }

                                                                                                        </div>
                                                                                                    </div>

                                                                                                    {item?.home_area_product_id_ids === isExpandedForAddMaintenance &&
                                                                                                        <div
                                                                                                            className="row mx-0 py-2 font-w700 d-flex align-items-center  border-bottom"
                                                                                                            style={{
                                                                                                                // background: 'rgb(199 212 234 / 30%)',
                                                                                                                // pointerEvents: 'none',
                                                                                                                // opacity: '0.5',
                                                                                                            }}
                                                                                                        >
                                                                                                            <div className="col-12 p-2">
                                                                                                                <div className="row mx-0">
                                                                                                                    <div className="col-12 px-0">
                                                                                                                        <InputField
                                                                                                                            labelName={"Instruction"}
                                                                                                                            value={instruction}
                                                                                                                            onChange={(e) => { handleChangeInstruction(e) }}
                                                                                                                            onBlur={() => { handleBlurCheckInstrction() }}
                                                                                                                            errorOccured={isInstructionErr}
                                                                                                                            errorMeesage={"Please enter instructions"}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className="row mx-0">
                                                                                                                    <div className="col-12 px-0">
                                                                                                                        <div className="row mx-0">
                                                                                                                            <div className="col-2 px-0 d-flex  justify-content-center">
                                                                                                                                <span className="font-w600 text-black">{`Every`}</span>
                                                                                                                            </div>
                                                                                                                            <div className="col-3 px-2">

                                                                                                                                <SelectInputFrequency
                                                                                                                                    labelName={"Times"}
                                                                                                                                    onChange={(e) => handleChangeFreq(e)}
                                                                                                                                    defaultValue={frequency}
                                                                                                                                    options={frequencyArr}
                                                                                                                                    errorOccured={isFrequencyErr}
                                                                                                                                    errorMessage={"Please select frequency"}
                                                                                                                                />

                                                                                                                            </div>
                                                                                                                            <div className="col-7 px-0">
                                                                                                                                <SelectInputPeriod
                                                                                                                                    labelName={"Period"}
                                                                                                                                    onChange={(e) => handleChangePeriod(e)}
                                                                                                                                    defaultValue={period}
                                                                                                                                    options={periodListArr}
                                                                                                                                    errorOccured={isPeriodErr}
                                                                                                                                    errorMessage={"Please select period"}
                                                                                                                                />
                                                                                                                            </div>

                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className="row mx-0">
                                                                                                                    <div className="col-12 px-0">
                                                                                                                        <InputField
                                                                                                                            labelName={"Purchase link (optional)"}
                                                                                                                            value={purchaseLink}
                                                                                                                            onChange={(e) => { handleChangePurchaseLink(e) }}
                                                                                                                            onBlur={() => { }}
                                                                                                                            errorOccured={false}
                                                                                                                            errorMeesage={"Please enter purchase link"}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>

                                                                                                                <div className="row mx-0">
                                                                                                                    <div className="col-12 px-0">
                                                                                                                        <PrimaryButton
                                                                                                                            buttonName={"SUBMIT"}
                                                                                                                            onClick={() => { addUpdateMaintenancePlanFn() }}
                                                                                                                            isLoading={maintenancePlanLoading}
                                                                                                                            loadingMessage={"Loading..."}
                                                                                                                            style={{
                                                                                                                                width: '100%',
                                                                                                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                                                                                                border: '2px solid rgba(255, 154, 32, 1)',
                                                                                                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                                                                                            }}
                                                                                                                        />
                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    }

                                                                                                    <div
                                                                                                        className="row mx-0 py-2 font-w700 d-flex align-items-center cursor-pointer text-hovered overlay-action-btn rounded-bottom"
                                                                                                        style={{
                                                                                                            background: 'rgb(199 212 234 / 30%)',
                                                                                                            // pointerEvents: 'none',
                                                                                                            // opacity: '0.5',
                                                                                                        }}
                                                                                                    >
                                                                                                        <div
                                                                                                            className="col-12 d-flex justify-content-center align-items-center"
                                                                                                            onClick={(e) => {
                                                                                                                e.stopPropagation();
                                                                                                                setIndividualProductObj(item);
                                                                                                                createServiceForInventoryItems(item);
                                                                                                            }}
                                                                                                        >
                                                                                                            <span>{`Create service request`}</span>
                                                                                                            <span>
                                                                                                                <i className="bi bi-person-gear ms-2"></i>
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    })}

                                                                    <div
                                                                        className="row mx-0"
                                                                        onClick={(e) => {
                                                                            setAreaId(element.area_id_ids);
                                                                            e.stopPropagation();
                                                                            handleOpenInventoryModal(1);
                                                                            setHomeAreaProductId('')
                                                                        }}
                                                                    >
                                                                        <div
                                                                            className="col-12 px-2 fs-5 font-w600 d-flex justify-content-center align-items-center cursor-pointer border-top rounded-bottom pt-2 pb-1 overlay-action-btn text-hovered">
                                                                            <span>{`Add item`}</span>
                                                                            <span>
                                                                                <i className="bi bi-plus-circle ms-2"></i>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })}
                                </> :
                                <>
                                    <div className="mt-5 d-flex justify-content-center align-items-center flex-column">

                                        <div className="mb-2">
                                            <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                        </div>
                                        <span>
                                            {`No rooms added`}
                                        </span>
                                    </div>
                                </>}

                            <hr />

                        </div>
                    </div> :
                    <></>
            }


            {/* <!-- Modal For the maintenance info --> */}
            <>
                <Modal className="fade" show={maintenanceInfoTrigger}
                    // onHide={handleClose} 
                    centered
                >
                    <Modal.Body>
                        <div className='row mx-0'>
                            <div className='col-12 px-0'>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                                        <span
                                            onClick={() => handleCloseMaintenanceInfoModal()}
                                            className='cursor-pointer text-hovered'
                                        >
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                        <span className="me-2 text-orange">
                                            <i className="bi bi-info-circle"></i>
                                        </span>
                                        <span>
                                            {`Why you want a home check-up`}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 mb-4">
                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center">
                                        <span>
                                            {`A home check-up allows you to easily maintain your home inventory to avoid costly repairs in the future.`}
                                        </span>
                                    </div>
                                </div>


                                <div className="row mx-0 ">
                                    <div className="col-12 px-0">
                                        <PrimaryButton
                                            buttonName={"GOT IT"}
                                            onClick={(e) => handleCloseMaintenanceInfoModal(e)}
                                            style={{
                                                width: '100%',
                                                background: 'rgba(251, 252, 255, 1)',
                                                border: '1px solid rgba(199, 212, 234, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                color: 'black',
                                                fontWeight: '700'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </>

            {/* <!-- Modal For the Room operations --> */}
            <>
                <Modal className="fade" show={roomModalTrigger}
                    // onHide={handleClose} 
                    centered
                >
                    <Modal.Body>
                        {/* Edit room list */}
                        {toggleForRoomModal === 1 &&
                            <div className='row mx-0'>
                                <div className='col-12 px-0'>
                                    <div className='mx-0 row text-black mb-4'>
                                        <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                                            <span
                                                onClick={() => handleCloseRoomModal()}
                                                className='cursor-pointer text-hovered'
                                            >
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                        <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                            <span>
                                                {`Define room list`}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row mx-0 mb-4">
                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center">
                                            <span>
                                                {`Set up which rooms you would like to review`}
                                            </span>
                                        </div>
                                    </div>

                                    {/* <div className="row mx-0 mb-2">
                                        <div className="col-12 px-0">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <span className="fs-5 font-w600">
                                                        {`${homeAreaIdListArr.length} rooms selected`}
                                                    </span>
                                                </div>
                                                <div></div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="row mx-0 ">
                                        <div className="col-12 px-0 overflow-auto pt-1"
                                            style={{
                                                maxHeight: '55dvh'
                                            }}
                                        >
                                            {refAreaListNewDesign.length > 0 ? <>
                                                {refAreaListNewDesign.map((element, index) => {
                                                    return (
                                                        <>
                                                            <div className="row bg-white mx-1 mb-2  rounded-2 "
                                                                style={{
                                                                    boxShadow: '0px 0px 3px #a8a4a4',
                                                                    opacity: roomsLoading ? '0.5' : '1',
                                                                    pointerEvents: roomsLoading ? 'none' : 'auto',
                                                                }}
                                                                key={index}
                                                            >
                                                                <div className="col-12 px-0">
                                                                    <div
                                                                        className={`d-flex align-items-center justify-content-between w-100 ${element?.ref_area_id_ids === isExpandedForAddRoom && 'border-bottom'} p-3 fs-5 font-w700 text-black cursor-pointer`}
                                                                        onClick={() => {
                                                                            if (element?.ref_area_id_ids === isExpandedForAddRoom) {
                                                                                setIsExpandedForAddRoom('')
                                                                            } else {
                                                                                setIsExpandedForAddRoom(element.ref_area_id_ids)
                                                                            }
                                                                            setRefAreaId(element?.ref_area_id_ids);
                                                                        }}
                                                                    >
                                                                        <div className="d-flex align-items-center justify-content-center">
                                                                            <div
                                                                                className="me-2 rounded d-flex align-items-center justify-content-center border"
                                                                                style={{ background: 'rgba(79, 93, 116, 1)', width: '30px', height: '30px' }}
                                                                            >
                                                                                <img
                                                                                    src={element?.ref_icon_url}
                                                                                    alt=""
                                                                                    className="rounded border"
                                                                                    style={{ width: "30px", height: "30px", background: 'rgba(79, 93, 116, 1)' }}
                                                                                />
                                                                            </div>
                                                                            <div
                                                                                style={{
                                                                                    color: 'rgba(131, 154, 192, 1)',
                                                                                    opacity: element?.home_area_count !== 0 ? '1' : '0.7',

                                                                                }}
                                                                            >
                                                                                <span>{`${element?.ref_display_area_name_chr}`}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex align-items-center justify-content-center">
                                                                            <div className="me-3">
                                                                                <span
                                                                                    className="text-hovered border-hovered cursor-pointer border rounded p-2"
                                                                                    style={{
                                                                                        pointerEvents: element?.home_area_count == 0 ? 'none' : 'auto',
                                                                                        opacity: element?.home_area_count == 0 ? '0.5' : '1',
                                                                                    }}
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation()
                                                                                        handleDeleteNewHomeAreaFn(element?.home_area_list[element?.home_area_list.length - 1]);
                                                                                        setIsExpandedForAddRoom(element.ref_area_id_ids)
                                                                                    }}
                                                                                >
                                                                                    <i className="bi bi-dash-lg"></i>
                                                                                </span>
                                                                            </div>
                                                                            <div className="me-3 d-flex align-items-center justify-content-center" style={{ width: '25px' }}>
                                                                                {`${element?.home_area_count}`}
                                                                            </div>
                                                                            <div>
                                                                                <span
                                                                                    className="text-hovered border-hovered cursor-pointer border rounded p-2"
                                                                                    onClick={(e) => {
                                                                                        // setRoomTypeName(`${element?.ref_display_area_name_chr} #${element?.home_area_count + 1}`)
                                                                                        // setRefAreaId(element?.ref_area_id_ids);
                                                                                        e.stopPropagation()
                                                                                        handleAddRoom(element)
                                                                                        setIsExpandedForAddRoom(element.ref_area_id_ids)
                                                                                    }}
                                                                                >
                                                                                    <i className="bi bi-plus-lg"></i>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    {element?.ref_area_id_ids === isExpandedForAddRoom &&
                                                                        <>
                                                                            {element?.home_area_list?.map((item, ind) => {
                                                                                return (
                                                                                    <>
                                                                                        <div
                                                                                            className={`row mx-0 p-3 d-flex align-items-baseline ${(ind !== element?.home_area_list?.length - 1) && 'border-bottom'}`}
                                                                                            key={ind}
                                                                                        >
                                                                                            <div className="col-9 px-0 d-flex align-items-center justify-content-center pe-2">
                                                                                                <div className="w-100">
                                                                                                    <InputField
                                                                                                        labelName={"Room name"}
                                                                                                        // value={roomTypeName}
                                                                                                        value={`${item?.area_id_ids !== isEditForRoomName ? item?.area_name_chr : roomTypeName}`}
                                                                                                        onChange={(e) => { handleChangeRoomName(e) }}
                                                                                                        onBlur={handleBlurCheckRoomName}
                                                                                                        errorOccured={isRoomTypeNameErr && item?.area_id_ids == isEditForRoomName}
                                                                                                        errorMeesage={"Enter valid room name"}
                                                                                                        disabled={item?.area_id_ids !== isEditForRoomName ? true : false}
                                                                                                    />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="col-3 px-0 d-flex align-items-center justify-content-evenly fs-4 ps-2">
                                                                                                {item?.area_id_ids !== isEditForRoomName ?
                                                                                                    <>
                                                                                                        <span className="pe-2">
                                                                                                            <i
                                                                                                                className="bi bi-pencil-fill text-hovered cursor-pointer"
                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    setIsEditForRoomName(item?.area_id_ids);
                                                                                                                    setAreaId(item?.area_id_ids);
                                                                                                                    setRoomTypeName(item?.area_name_chr);
                                                                                                                    isRoomTypeNameErr && setIsRoomTypeNameErr(false);
                                                                                                                }}
                                                                                                            ></i>
                                                                                                        </span>

                                                                                                        <span>
                                                                                                            <i
                                                                                                                className="bi bi-trash text-hovered cursor-pointer"

                                                                                                                onClick={(e) => {
                                                                                                                    e.stopPropagation();
                                                                                                                    handleDeleteNewHomeAreaFn(item);
                                                                                                                }}
                                                                                                            ></i>
                                                                                                        </span>
                                                                                                    </> :
                                                                                                    <>
                                                                                                        <span
                                                                                                            className="px-3 py-2 text-hovered cursor-pointer overlay-action-btn rounded font-w600"
                                                                                                            onClick={() => {
                                                                                                                handleAddRoom(item)
                                                                                                            }}
                                                                                                        >
                                                                                                            {`Save`}
                                                                                                        </span>
                                                                                                    </>
                                                                                                }
                                                                                            </div>
                                                                                        </div>
                                                                                    </>
                                                                                )
                                                                            })

                                                                            }
                                                                        </>
                                                                    }


                                                                </div>
                                                            </div>
                                                        </>
                                                    )
                                                })}
                                            </> :
                                                <>
                                                    <div className="mt-1 mb-3 d-flex justify-content-center align-items-center flex-column">

                                                        <div className="mb-2">
                                                            <img src={searchImg} alt="search" style={{ width: "70px" }} />
                                                        </div>
                                                        <span>
                                                            {`No rooms available`}
                                                        </span>
                                                    </div>
                                                </>
                                            }

                                        </div>
                                    </div>

                                    {/* <div className="row mx-0 mb-2 mt-3">
                                        <div className="col-12 px-0">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex">
                                                    <span className="">
                                                        {`Need another option? `}
                                                    </span>

                                                    <div
                                                        className="ms-3 text-hovered cursor-pointer d-flex align-items-center font-w600"
                                                        style={{
                                                            color: 'rgba(131, 154, 192, 1)'
                                                        }}
                                                        onClick={() => setToggleForRoomModal(2)}
                                                    >
                                                        <span className="">
                                                            {`Add rooom manually`}
                                                        </span>
                                                        <span>
                                                            <i className="bi bi-plus-circle ms-2"></i>
                                                        </span>
                                                    </div>

                                                </div>
                                                <div></div>
                                            </div>
                                        </div>
                                    </div> */}

                                    <div className="row mx-0 mt-3">
                                        <div className="col-12 px-0">
                                            <PrimaryButton
                                                buttonName={"CONTINUE"}
                                                onClick={() => {
                                                    // handleCloseRoomModal();
                                                    getHomeAreaListonContinue();
                                                }}
                                                // isLoading={roomsLoading}
                                                isLoading={defineRoomsLoading}
                                                loadingMessage={"CONTINUING..."}
                                                style={{
                                                    width: '100%',
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {/* Add new room manually */}
                        {toggleForRoomModal === 2 &&
                            <div className='row mx-0'>
                                <div className='col-12 px-0'>
                                    <div className='mx-0 row text-black mb-4'>
                                        <div className='col-12 d-flex fs-4 align-items-center px-0'>
                                            <div className="d-flex align-items-center justify-content-between w-100">
                                                <div
                                                    className="d-flex text-black text-hovered cursor-pointer fs-5"
                                                    onClick={() => setToggleForRoomModal(1)}
                                                >
                                                    <span>
                                                        <i className="bi bi-arrow-left me-2"></i>
                                                    </span>
                                                    <span>
                                                        {`Back`}
                                                    </span>
                                                </div>

                                                <div>
                                                    <span
                                                        onClick={() => handleCloseRoomModal()}
                                                        className='cursor-pointer text-hovered'
                                                    >
                                                        <i className="bi bi-x-lg"></i>
                                                    </span>
                                                </div>
                                            </div>

                                        </div>
                                        <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                            <span>
                                                {`Add room`}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row mx-0 mb-4">
                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center">
                                            <span>
                                                {`Enter the name of the room you want to add to the list`}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="row mx-0">
                                        <div className="col-12 px-0">
                                            <InputField
                                                labelName={"Room name"}
                                                value={roomTypeName}
                                                onChange={(e) => { handleChangeRoomName(e) }}
                                                onBlur={handleBlurCheckRoomName}
                                                errorOccured={isRoomTypeNameErr}
                                                errorMeesage={"Enter valid room name"}
                                            />
                                        </div>
                                    </div>

                                    <div className="row mx-0 ">
                                        <div className="col-12 px-0">
                                            <PrimaryButton
                                                buttonName={"SUBMIT"}
                                                onClick={() => handleSubmitRoomOperations()}
                                                isLoading={roomsLoading}
                                                loadingMessage={"Loading..."}
                                                style={{
                                                    width: '100%',
                                                    background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                    border: '2px solid rgba(255, 154, 32, 1)',
                                                    boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </Modal.Body>
                </Modal>
            </>

            {/* <!-- Modal For the inventory items operations --> */}
            <>
                <Modal className="fade" show={inventoryModalTrigger}
                    // onHide={handleClose} 
                    centered
                >
                    <Modal.Body>
                        <div className='row mx-0'>
                            <div className='col-12 px-0'>
                                <div className='mx-0 row text-black mb-3'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                                        <span
                                            onClick={() => handleCloseInventoryModal()}
                                            className='cursor-pointer text-hovered'
                                        >
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {toggleForInventoryModal === 1 ? `Add inventory item` :
                                                toggleForInventoryModal === 2 ? `Edit ${inventoryType}` :
                                                    toggleForInventoryModal === 3 ? `Delete inventory item` :
                                                        toggleForInventoryModal === 4 ? `Create service for ${inventoryType}` : ''
                                            }
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 mb-3">
                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center">
                                        <span>
                                            {(toggleForInventoryModal === 1 || toggleForInventoryModal === 2) && `Fill in the main properties of the inventory item`}
                                            {(toggleForInventoryModal === 3) && `Are you sure you want to delete ${inventoryType} from this room?`}
                                            {(toggleForInventoryModal === 4) && `Are you sure you want to create service for ${inventoryType} from this room?`}
                                        </span>
                                    </div>
                                </div>

                                {(toggleForInventoryModal === 1 || toggleForInventoryModal === 2) &&
                                    <div>
                                        {toggleForInventoryModal === 1 &&
                                            <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                    <SelectInputProductTypes
                                                        labelName={"Inventory type"}
                                                        onChange={(e) => handleChangeInventoryType(e)}
                                                        defaultValue={inventoryType}
                                                        options={productTypeArr}
                                                        errorOccured={isInventoryTypeErr}
                                                        errorMessage={"Please select inventory type"}
                                                    // isForProdId={true}
                                                    />
                                                </div>
                                            </div>
                                        }


                                        {/* <div className="row mx-0">
                                            <div className="col-12 px-0">
                                                <SelectInputCondition
                                                    labelName={"Condition"}
                                                    onChange={(e) => handleChangeInventoryCondition(e)}
                                                    defaultValue={inventoryCondition}
                                                    options={conditionListArr}
                                                    errorOccured={false}
                                                    errorMessage={"Please select device condition"}
                                                />
                                            </div>
                                        </div> */}

                                        <div className="row mx-0 fs-5 mb-2">
                                            <div className="col-4 pe-2 font-w600">
                                                <span>{`Condition `}</span>
                                            </div>

                                            <div className="col-8 ps-2">
                                                <div className="d-flex overflow-auto pb-1 w-100">
                                                    {conditionListArr.map((item, index) => {
                                                        return (
                                                            <>
                                                                {item?.condition_id_ids !== 0 &&
                                                                    <span
                                                                        key={index}
                                                                        className="font-w500 me-2 px-3 py-1 rounded-pill text-white cursor-pointer"
                                                                        onClick={() => { setInventoryCondition(item?.condition_name_chr) }}
                                                                        style={{
                                                                            background:
                                                                                (inventoryCondition === "Good" && item?.condition_name_chr === "Good") ? "rgba(45, 204, 99, 1)" :
                                                                                    (inventoryCondition === "Ok" && item?.condition_name_chr === "Ok") ? "rgba(255, 154, 32, 1)" :
                                                                                        (inventoryCondition === "Poor" && item?.condition_name_chr === "Poor") ? "rgba(240, 72, 72, 1)" : `rgba(131, 154, 192, 1)`,
                                                                            boxShadow:
                                                                                (inventoryCondition === "Good" && item?.condition_name_chr === "Good") ? '1px 1px 2px 0px grey' :
                                                                                    (inventoryCondition === "Ok" && item?.condition_name_chr === "Ok") ? '1px 1px 2px 0px grey' :
                                                                                        (inventoryCondition === "Poor" && item?.condition_name_chr === "Poor") ? '1px 1px 2px 0px grey' : `0px 0px 2px 0px grey`,
                                                                        }}
                                                                    >
                                                                        {`${item?.condition_name_chr}`}
                                                                    </span>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row mx-0">
                                            <div className="col-8 px-0 pe-2">
                                                <div className="row mx-0">
                                                    <div className="col-12 px-0">
                                                        <InputField
                                                            labelName={"Brand"}
                                                            value={inventoryBrand}
                                                            onChange={(e) => { handleChangeInventoryBrand(e) }}
                                                            onBlur={(e) => { }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mx-0">
                                                    <div className="col-12 px-0">
                                                        <InputField
                                                            labelName={"Model"}
                                                            value={inventoryModel}
                                                            onChange={(e) => { handleChangeInventoryModel(e) }}
                                                            onBlur={(e) => { }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row mx-0">
                                                    <div className="col-12 px-0">
                                                        <InputField
                                                            labelName={"Serial #"}
                                                            value={inventorySerialNumber}
                                                            onChange={(e) => { handleChangeInventorySerialNumber(e) }}
                                                            onBlur={(e) => { }}
                                                        />
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="col-4 ps-2">
                                                <div
                                                    className="d-flex justify-content-center align-items-center bg-black rounded-2 border cursor-pointer overlay-action-btn"
                                                    style={{
                                                        height: `calc(100% - 15px)`,
                                                        background: `rgba(244, 248, 255, 1)`,
                                                    }}
                                                    onClick={() => {
                                                        handleOpenOcrModal();
                                                        // startCameraOcr();
                                                        getMediaStream();
                                                    }}
                                                >
                                                    <div className="d-flex justify-content-center align-items-center flex-column">
                                                        <div className="fs-2 mb-2">
                                                            <MdOutlineDocumentScanner />
                                                        </div>
                                                        <span className="text-black font-w500 text-center">{`Auto-Detect`}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* <div className="row mx-0">
                                            <div className="col-12 px-0">
                                                <InputField
                                                    labelName={"Brand"}
                                                    value={inventoryBrand}
                                                    onChange={(e) => { handleChangeInventoryBrand(e) }}
                                                    onBlur={(e) => { }}
                                                />
                                            </div>
                                        </div> */}
                                        {/*
                                        <div className="row mx-0">
                                            <div className="col-sm-6 pe-sm-2">
                                                <InputField
                                                    labelName={"Model"}
                                                    value={inventoryModel}
                                                    onChange={(e) => { handleChangeInventoryModel(e) }}
                                                    onBlur={(e) => { }}
                                                />
                                            </div>

                                            <div className="col-sm-6 ps-sm-2">
                                                <InputField
                                                    labelName={"Serial #"}
                                                    value={inventorySerialNumber}
                                                    onChange={(e) => { handleChangeInventorySerialNumber(e) }}
                                                    onBlur={(e) => { }}
                                                />
                                            </div>
                                        </div> */}


                                        <div className="row mx-0">
                                            <div className="col-12 px-0">
                                                <TextArea
                                                    labelName={"Description (optional)"}
                                                    value={inventoryDesc}
                                                    rows={3}
                                                    onChange={(e) => { handleChangeInventoryDesc(e) }}
                                                    onBlur={(e) => { }}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mx-0 ">
                                            <div className="col-sm-6 pe-sm-2 mb-2 d-flex align-items-center">
                                                <div
                                                    className="text-hovered fs-5 cursor-pointer d-flex align-items-center font-w600"
                                                    onClick={handleClickAttachedImage0}
                                                >
                                                    <span className="me-2">
                                                        <i className="bi bi-paperclip"></i>
                                                    </span>
                                                    <span>
                                                        {`Attach file`}
                                                    </span>
                                                    <input ref={attachedImage0Ref} type="file" accept="image/*" hidden onChange={(e) => { handleAttachedImage0(e) }} />
                                                </div>
                                            </div>

                                            <div className="col-sm-6 ps-sm-2 mb-2">
                                                <PrimaryButton
                                                    buttonName={"SUBMIT"}
                                                    onClick={(e) => { addUpdateinventoryItemFn() }}
                                                    isLoading={inventoryLoading}
                                                    loadingMessage={"Loading..."}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        {attachedImage0 &&
                                            <div className="row mx-0 mt-2">
                                                <div className="col-12 px-0 d-flex">
                                                    <div className="position-relative">
                                                        <i
                                                            onClick={deleteAttachedImage0}
                                                            className="bi bi-x-circle position-absolute cursor-pointer fs-3 text-orange bg-white rounded-circle"
                                                            style={{
                                                                top: '-10px',
                                                                right: '-10px',
                                                            }}
                                                        ></i>
                                                        <img
                                                            src={attachedImage0}
                                                            className="rounded-2 shadow-lg border border-danger"
                                                            alt="Attachement"
                                                            style={{
                                                                height: '50px',
                                                                width: '50px',
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }

                                {(toggleForInventoryModal === 3) &&
                                    <>
                                        <div className="row mx-0">
                                            <div className="col-sm-6 pe-sm-2 mb-2">
                                                <PrimaryButton
                                                    buttonName={"NO, GO BACK"}
                                                    onClick={(e) => { handleCloseInventoryModal() }}
                                                    isLoading={false}
                                                    loadingMessage={"Loading..."}
                                                    style={{
                                                        width: '100%',
                                                        background: 'rgba(251, 252, 255, 1)',
                                                        border: '1px solid rgba(199, 212, 234, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                        color: 'black',
                                                        fontWeight: '600'
                                                    }}
                                                />
                                            </div>

                                            <div className="col-sm-6 ps-sm-2 mb-2">
                                                <PrimaryButton
                                                    buttonName={"YES, DELETE IT"}
                                                    onClick={(e) => { deleteInventoryItemFn() }}
                                                    isLoading={inventoryLoading}
                                                    loadingMessage={"Loading..."}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                        border: '1px solid rgba(240, 72, 72, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                        fontWeight: '600'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }


                                {(toggleForInventoryModal === 4) &&
                                    <>
                                        <div className="row mx-0">
                                            <div className="col-sm-6 pe-sm-2 mb-2">
                                                <PrimaryButton
                                                    buttonName={"NO, GO BACK"}
                                                    onClick={(e) => { handleCloseInventoryModal() }}
                                                    isLoading={false}
                                                    loadingMessage={"Loading..."}
                                                    style={{
                                                        width: '100%',
                                                        background: 'rgba(251, 252, 255, 1)',
                                                        border: '1px solid rgba(199, 212, 234, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                        color: 'black',
                                                        fontWeight: '600'
                                                    }}
                                                />
                                            </div>

                                            <div className="col-sm-6 ps-sm-2 mb-2">
                                                <PrimaryButton
                                                    buttonName={"CREATE SERVICE"}
                                                    onClick={(e) => {
                                                        // createServiceRequestFn()
                                                        handleOpenInsectionConfirmationModal();
                                                        setInventoryModalTrigger(false);
                                                    }}
                                                    // isLoading={inventoryLoading}
                                                    // loadingMessage={"Loading..."}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                        fontWeight: '600'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </>

            {/* Modal for previewing the attached image preview */}
            <>
                <Modal show={openDoc} onHide={handleCloseDoc} centered style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>

                        <a href={imageAttachURL} target="_blank" rel="noreferrer">
                            <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                        </a>

                        <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>
                    <>
                        <img src={imageAttachURL} alt='Error Loading' style={{ width: '100%', height: '100%' }} />
                    </>

                </Modal>
            </>

            {/* OCR modal old code */}
            <Modal
                className="fade"
                show={false}
                style={{}}
                centered
                size=""
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <>
                                <div className="mx-0 row">
                                    <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                        <span
                                            onClick={() => handleCloseOcrModal()}
                                            className="cursor-pointer">
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className="mx-0 row mb-2">
                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                        <span>{"Scan info"}</span>
                                    </div>
                                </div>

                                <div
                                    className="mx-0 row  mb-3 "
                                    style={{ height: "400px", width: "100%", position: "relative" }}>
                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black position-relative">
                                        {ocrLoading && <ResponceForAPI show={ocrLoading} />}
                                        <span
                                            className="position-absolute fs-7"
                                            style={{
                                                top: "10px",
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                zIndex: "1",
                                            }}
                                        >
                                            {"Focus your camera on model number"}
                                        </span>

                                        {!isCameraAllowed &&
                                            <span
                                                className="position-absolute fs-5 text-center text-white"
                                                style={{
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    zIndex: "1",
                                                }}>
                                                {"Please allow camera access from settings"}
                                            </span>
                                        }

                                        <video
                                            ref={videoRefOcr}
                                            autoPlay
                                            playsInline
                                            width="100%"
                                            height="400px"
                                            style={{
                                                objectFit: "cover",
                                                border: "2px solid #ff7a35",
                                                backgroundColor: "black",
                                            }}
                                            muted={true}></video>
                                        <canvas
                                            ref={canvasRefOcr}
                                            // width="640"
                                            // height="400"
                                            style={{ display: "none" }}></canvas>

                                        {/* <div
                                            ref={cropRef}
                                            style={{
                                                position: "absolute",
                                                border: "2px dashed #ff7a35",
                                                top: crop.y,
                                                left: crop.x,
                                                width: crop.width,
                                                height: crop.height,
                                                cursor: "nwse-resize",
                                            }}
                                            onMouseDown={handleMouseDown}
                                        ></div> */}

                                    </div>
                                </div>

                                <div className="mx-0 row mb-2">
                                    <div
                                        className="col-12 font-w600 px-0 text-center text-black "
                                        style={{
                                            pointerEvents: isCameraAllowed ? 'auto' : 'none',
                                            opacity: isCameraAllowed ? 1 : 0.5,
                                        }}
                                    >
                                        <PrimaryButton
                                            buttonName={"scan"}
                                            onClick={captureImageOcr}
                                            style={{ width: "100%" }}
                                            loadingMessage={"Scanning number..."}
                                            isLoading={ocrLoading}
                                        />
                                    </div>
                                </div>

                                <div className='mx-0 row mb-2'>
                                    <div className='col-12 font-w600 px-0 text-center text-black '>
                                        {capturedImage && <img src={capturedImage} alt="Captured" style={{ width: '100%', height: '100%' }} />}
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>


            {/* OCR modal new with crop feature */}
            <Modal
                className="fade"
                show={ocrModalTrigger}
                style={{}}
                centered
                size=""
            >
                <Modal.Body style={{}}>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <>
                                <div className="mx-0 row">
                                    <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                        <span
                                            onClick={() => handleCloseOcrModal()}
                                            className="cursor-pointer">
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className="mx-0 row mb-2">
                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                        <span>{"Scan info"}</span>
                                    </div>
                                </div>

                                <div className="row mx-0 mb-3">
                                    <div className="col-12 px-0 position-relative d-flex justify-content-center align-items-center">
                                        {ocrLoading && <ResponceForAPI show={ocrLoading} />}
                                        {!isCameraAllowed &&
                                            <span
                                                className="position-absolute fs-5 text-center text-white"
                                                style={{
                                                    top: "50%",
                                                    left: "50%",
                                                    transform: "translate(-50%, -50%)",
                                                    zIndex: "1",
                                                }}>
                                                {"Please allow camera access from settings to use OCR"}
                                            </span>
                                        }
                                        {canvasEnabled && (
                                            <canvas
                                                id="canvasFrame"
                                                width={videoWidth}
                                                height={videoHeight}
                                                style={{
                                                    position: "absolute",
                                                    zIndex: "9",
                                                    cursor: "crosshair",
                                                }}>

                                            </canvas>
                                        )}

                                        <canvas
                                            id="canvasImage"
                                            width={videoWidth}
                                            height={videoHeight}
                                            style={{ display: "none" }}>
                                        </canvas>
                                        {canvasEnabled && (
                                            <canvas
                                                id="canvasFinalImage"
                                                style={{ position: "absolute", zIndex: "-1" }}>
                                            </canvas>
                                        )}
                                        <video
                                            ref={videoRef}
                                            width={videoWidth}
                                            height={videoHeight}
                                            id="videoFrame"
                                            playsInline
                                            autoPlay={true}
                                            style={{ objectFit: "cover", border: "2px solid #ff7a35", backgroundColor: "black" }}
                                            muted={true}></video>
                                    </div>
                                </div>

                                <div className="row mx-0 mb-2">
                                    <div
                                        className="col-12 px-0 d-flex justify-content-center align-items-center"
                                        style={{
                                            pointerEvents: isCameraAllowed ? 'auto' : 'none',
                                            opacity: isCameraAllowed ? 1 : 0.5,
                                        }}
                                    >
                                        {/* <button onClick={toggleFlashlight}>
                                            {flashlightOn ? "Turn Off Flashlight" : "Turn On Flashlight"}
                                        </button> */}

                                        {!canvasEnabled && !ocrLoading && (
                                            <div className="">
                                                <PrimaryButton
                                                    onClick={() => {
                                                        canvasEnableFn();
                                                    }}
                                                    buttonName={"Scan info"}
                                                    style={{ width: '180px' }}
                                                />
                                            </div>
                                        )}
                                        {canvasEnabled && !ocrLoading && (
                                            <div className="">
                                                <Button
                                                    onClick={() => {
                                                        canvasEnableFn();
                                                    }}
                                                    variant="success"
                                                    className="scan-tab-bottom-btn"
                                                >
                                                    {"Crop"}
                                                </Button>
                                            </div>
                                        )}

                                        {ocrLoading && (
                                            <div className="">
                                                <Button
                                                    variant="success"
                                                    disabled
                                                    className="scan-tab-bottom-btn"
                                                >
                                                    {"Scanning..."}
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* <div className='mx-0 row mb-2'>
                                    <div className='col-12 font-w600 px-0 text-center text-black '>
                                        {displayImage && <img src={displayImage} alt="Captured" style={{ width: '100%', height: '100%' }} />}
                                    </div>
                                </div> */}

                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* <!-- Modal For the Maintenance plans operations --> */}
            <>
                <Modal
                    className="fade"
                    show={maintenanceModalTrigger}
                    centered
                // onHide={handleClose} 
                >
                    <Modal.Body>
                        <div className='row mx-0'>
                            <div className='col-12 px-0'>
                                <div className='mx-0 row text-black mb-3'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                                        <span
                                            onClick={() => handleCloseMaintenancePlanModal()}
                                            className='cursor-pointer text-hovered'
                                        >
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {toggleForMaintenancePlan === 1 ? `Edit maintenance plan` :
                                                toggleForMaintenancePlan === 2 ? `Delete maintenance plan` : ''
                                            }
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 mb-3">
                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center">
                                        <span>
                                            {(toggleForMaintenancePlan === 1) && `Fill in a maintenance plan for the item`}
                                            {(toggleForMaintenancePlan === 2) && `Are you sure you want to delete the ${instruction ? `"${instruction}"` : ''} maintenace plan?`}
                                        </span>
                                    </div>
                                </div>

                                {(toggleForMaintenancePlan === 1) &&
                                    <div
                                        className="row mx-0 py-2 font-w700 d-flex align-items-center"
                                        style={{
                                            // background: 'rgb(199 212 234 / 30%)',
                                            // pointerEvents: 'none',
                                            // opacity: '0.5',
                                        }}
                                    >
                                        <div className="col-12 p-2">
                                            <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                    <InputField
                                                        labelName={"Instruction"}
                                                        value={instruction}
                                                        onChange={(e) => { handleChangeInstruction(e) }}
                                                        onBlur={() => { handleBlurCheckInstrction() }}
                                                        errorOccured={isInstructionErr}
                                                        errorMeesage={"Please enter instructions"}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                    <div className="row mx-0">
                                                        <div className="col-2 px-0 d-flex  justify-content-center">
                                                            <span className="font-w600 text-black">{`Every`}</span>
                                                        </div>
                                                        <div className="col-3 px-2">

                                                            <SelectInputFrequency
                                                                labelName={"Times"}
                                                                onChange={(e) => handleChangeFreq(e)}
                                                                defaultValue={frequency}
                                                                options={frequencyArr}
                                                                errorOccured={isFrequencyErr}
                                                                errorMessage={"Please select frequency"}
                                                            />

                                                        </div>
                                                        <div className="col-7 px-0">
                                                            <SelectInputPeriod
                                                                labelName={"Period"}
                                                                onChange={(e) => handleChangePeriod(e)}
                                                                defaultValue={period}
                                                                options={periodListArr}
                                                                errorOccured={isPeriodErr}
                                                                errorMessage={"Please select period"}
                                                            />
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                    <InputField
                                                        labelName={"Purchase link (optional)"}
                                                        value={purchaseLink}
                                                        onChange={(e) => { handleChangePurchaseLink(e) }}
                                                        onBlur={() => { }}
                                                        errorOccured={false}
                                                        errorMeesage={"Please enter purchase link"}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row mx-0">
                                                <div className="col-12 px-0">
                                                    <PrimaryButton
                                                        buttonName={"SUBMIT"}
                                                        onClick={() => { addUpdateMaintenancePlanFn() }}
                                                        isLoading={maintenancePlanLoading}
                                                        loadingMessage={"Loading..."}
                                                        style={{
                                                            width: '100%',
                                                            background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                            border: '2px solid rgba(255, 154, 32, 1)',
                                                            boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {(toggleForMaintenancePlan === 2) &&
                                    <>
                                        <div className="row mx-0">
                                            <div className="col-sm-6 pe-sm-2 mb-2">
                                                <PrimaryButton
                                                    buttonName={"NO, GO BACK"}
                                                    onClick={(e) => { handleCloseMaintenancePlanModal() }}
                                                    isLoading={false}
                                                    loadingMessage={"Loading..."}
                                                    style={{
                                                        width: '100%',
                                                        background: 'rgba(251, 252, 255, 1)',
                                                        border: '1px solid rgba(199, 212, 234, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                        color: 'black'
                                                    }}
                                                />
                                            </div>

                                            <div className="col-sm-6 ps-sm-2 mb-2">
                                                <PrimaryButton
                                                    buttonName={"YES, DELETE IT"}
                                                    onClick={(e) => { deletemaintenancePlanFn() }}
                                                    isLoading={maintenancePlanLoading}
                                                    loadingMessage={"Loading..."}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                        border: '1px solid rgba(240, 72, 72, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </>


            {/* <!-- Modal For the inspection confirmation --> */}
            <>
                <Modal className="fade" show={modalTriggerForInspectionConfirmation}
                    // onHide={handleClose} 
                    centered
                >
                    <Modal.Body>
                        <div className='row mx-0'>
                            <div className='col-12 px-0'>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                                        <span
                                            onClick={() => handleCloseInsectionConfirmationModal()}
                                            className='cursor-pointer text-hovered'
                                        >
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center'>

                                        <span>
                                            {`A home check-up with a Pro-Inspector`}
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 mb-4">
                                    <div className="col-12 px-0 d-flex justify-content-center align-items-center text-center">
                                        <span>
                                            {`Entrusting the inspection process to the experienced Pro is a good choice. Watch our short video guide to get familiar with all the steps you and a Pro will easily go through during the effective check-up process.`}
                                        </span>
                                    </div>
                                </div>


                                <div className="row mx-0 ">
                                    <div className="col-sm-6 pe-sm-2 mb-2">
                                        <PrimaryButton
                                            buttonName={"CONNECT NOW"}
                                            onClick={(e) => {
                                                if (paymentGatewayFlag) {
                                                    // setPaymentModal(true)
                                                    handleOpenPaymentModalTrigger();
                                                } else {
                                                    // submitFeedback();
                                                    createServiceRequestFn();
                                                }
                                            }}
                                            style={{
                                                width: '100%',
                                                background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                border: '1px solid rgba(255, 154, 32, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                fontSize: '10px',
                                            }}
                                        />
                                    </div>

                                    <div className="col-sm-6 ps-sm-2 mb-2">
                                        <PrimaryButton
                                            buttonName={"SCHEDULE CHECK-UP"}
                                            onClick={(e) => { handleOpenScheduleModal() }}
                                            style={{
                                                width: '100%',
                                                background: 'rgba(251, 252, 255, 1)',
                                                border: '1px solid rgba(199, 212, 234, 1)',
                                                boxShadow: '0px 6px 12px 0px rgba(102, 129, 172, 0.12)',
                                                color: 'black',
                                                fontWeight: '700',
                                                fontSize: '10px',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </>

            {/* New modal for payment confirmation */}
            <Modal
                className="fade"
                show={paymentConfirmModal}
                style={{}}
                centered
                size="lg"
            >
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <>
                                <div>
                                    <div className="mx-0 row">
                                        <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                            <span
                                                onClick={() => handleClosePaymentModalTrigger()}
                                                className="cursor-pointer">
                                                <i className="bi bi-x-lg"></i>
                                            </span>
                                        </div>
                                    </div>

                                    <div className="mx-0 row mb-4">
                                        <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                            <span>{`Confirm payment`}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="row mx-0">
                                    <div className="col-lg-6 pe-lg-2 ">
                                        <div className=" p-4 border">
                                            <div className="border-bottom mx-0 pb-3 row">
                                                <div className="col-12 px-0 d-flex align-items-center">
                                                    <div className="  h-100" style={{ width: "80px" }}>
                                                        <img
                                                            className=""
                                                            src={houseImg}
                                                            alt=""
                                                            style={{ width: "80px", height: "100px", objectFit: "contain" }}

                                                        />
                                                    </div>
                                                    <div className="d-flex flex-column h-100 ps-3 w-100">
                                                        <div className="row mx-0">
                                                            <div className="col-12 px-0 d-flex align-items-center justify-content-between">
                                                                <div className="fs-7">
                                                                    <span className="text-black font-w500">{`Created: `}</span>
                                                                    <span className="font-w600">
                                                                        {formatUnixTimestamp(
                                                                            Math.floor(new Date().getTime() / 1000)
                                                                        )}
                                                                    </span>
                                                                </div>

                                                                <div>
                                                                    {/* <i
                                                                        className="bi bi-pencil-fill ps-2 fs-6 text-black cursor-pointer text-hovered"
                                                                        onClick={() => {
                                                                            // setResponseBox(true);
                                                                            setPaymentConfirmModal(false);
                                                                        }}></i> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row mt-1">
                                                            <div className="col-12 px-0">
                                                                <span className="fs-5 fw-bold text-black">
                                                                    {`Problem description not specified`}
                                                                </span>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-12 px-0">
                                                                <span className="fs-7">{`Any Pro from Chilll network`}</span>
                                                            </div>
                                                        </div>

                                                        <div className="row mt-1">
                                                            <div className="col-12 px-0 d-flex align-items-center justify-content-end">
                                                                <div
                                                                    className=" px-3 py-1 rounded-pill fs-7 text-white font-w600"
                                                                    style={{
                                                                        zIndex: 1,
                                                                        background: "rgba(79, 93, 116, 1)",
                                                                    }}>
                                                                    <span>
                                                                        {` ${categoryName ? categoryName : 'Inspection'} ${(inventoryType) &&
                                                                            `/ ${inventoryType}`}`}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row mx-0 py-2">
                                                <div className="col-12 px-0 d-flex align-items-center">
                                                    <span className="fs-5 font-w600 text-black">{`Price details`}</span>
                                                </div>
                                            </div>

                                            <div className="row mx-0 pb-2 ">
                                                <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <span className=" text-black">{`${callDurationTimeLimit} minutes with a Pro`}</span>
                                                        <i className="bi bi-info-circle  ps-2"></i>
                                                    </div>
                                                    <span className=" font-w600 text-black">{`${USDollar.format(
                                                        parseFloat(callChargeAmount?.toFixed(2))
                                                    )}`}</span>
                                                </div>
                                            </div>

                                            {verifiedPromoCode && (
                                                <div className="row mx-0 pb-2">
                                                    <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <span className=" text-black">
                                                                {"Promo code discount"}
                                                            </span>
                                                        </div>
                                                        <span className=" font-w600 text-success">{`-${USDollar.format(
                                                            parseFloat(callChargeAmount?.toFixed(2)) -
                                                            parseFloat(
                                                                finalAmountAfterPromoCodeApplied?.toFixed(2)
                                                            )
                                                        )}`}</span>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="row mx-0 border-bottom"></div>

                                            <div
                                                style={{
                                                    pointerEvents: (parseFloat(totalCreditsInCents?.toFixed(2) / 100) >= parseFloat(callChargeAmount?.toFixed(2))) ? 'auto' : 'none',
                                                    opacity: (parseFloat(totalCreditsInCents?.toFixed(2) / 100) >= parseFloat(callChargeAmount?.toFixed(2))) ? 1 : 0.5,
                                                }}
                                            >
                                                <div className="row mx-0 py-2">
                                                    <div className="col-12 px-0 d-flex align-items-center">
                                                        <span className="fs-5 font-w600 text-black">{`Chilll credit balance`}</span>
                                                    </div>
                                                </div>

                                                <div className="row mx-0 pb-2 ">
                                                    <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                                                        <div className="d-flex">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="refund"
                                                                name="refund"
                                                                onChange={(e) => { setIsCreditsUsed(!isCreditsUsed) }}
                                                                value={isCreditsUsed}
                                                                checked={isCreditsUsed}
                                                            />
                                                            <span
                                                                className='ps-3 pt-1 text-black cursor-pointer'
                                                                onClick={() => { setIsCreditsUsed(!isCreditsUsed) }}
                                                            >
                                                                {`Available balance`}
                                                            </span>
                                                        </div>
                                                        {!isCreditsUsed ?
                                                            <span className=" font-w600 text-black">{`${USDollar.format(
                                                                parseFloat(totalCreditsInCents?.toFixed(2) / 100)
                                                            )}`}</span> :
                                                            <span className=" font-w600 text-black">{`
                                                                          (${USDollar.format(parseFloat(totalCreditsInCents?.toFixed(2) / 100))} - ${USDollar.format(parseFloat(callChargeAmount?.toFixed(2)))}) = 
                                                                          ${USDollar.format(
                                                                (parseFloat(totalCreditsInCents?.toFixed(2) / 100) - parseFloat(callChargeAmount?.toFixed(2)))
                                                            )}`}</span>
                                                        }
                                                    </div>
                                                </div>

                                                {(parseFloat(totalCreditsInCents?.toFixed(2) / 100) < parseFloat(callChargeAmount?.toFixed(2))) && <div className="row mx-0 pb-2 ">
                                                    <div className="col-12 px-0 d-flex justify-content-between align-items-center">
                                                        <div className="d-flex">
                                                            <span
                                                                className='text-black'
                                                            >
                                                                {`(Your credit balance is insufficient to use)`}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>}
                                            </div>

                                            <div className="row mx-0 border-bottom"></div>

                                            <div className="row mx-0 py-2 ">
                                                <div className="col-12 px-0 d-flex justify-content-between align-items-center fs-4">
                                                    <span className="  font-w600  text-black">
                                                        {"Total"}
                                                    </span>

                                                    {isCreditsUsed ?
                                                        <>
                                                            <span className=" font-w600 text-black">
                                                                {`${USDollar.format(
                                                                    parseFloat(
                                                                        finalAmountAfterPromoCodeApplied?.toFixed(2)
                                                                    )
                                                                )}`}
                                                            </span>
                                                        </> : <>
                                                            {!verifiedPromoCode && (
                                                                <span className=" font-w600 text-black">
                                                                    {`${USDollar.format(
                                                                        parseFloat(callChargeAmount?.toFixed(2))
                                                                    )}`}
                                                                </span>
                                                            )}
                                                            {verifiedPromoCode && (
                                                                <span className=" font-w600 text-black">
                                                                    {`${USDollar.format(
                                                                        parseFloat(
                                                                            finalAmountAfterPromoCodeApplied?.toFixed(2)
                                                                        )
                                                                    )}`}
                                                                </span>
                                                            )}
                                                        </>}

                                                </div>
                                            </div>

                                            {!isCreditsUsed &&
                                                <div className="row mx-0 py-2 ">
                                                    <div className="col-sm-7 pe-sm-1 d-flex  align-items-center">
                                                        <div className="w-100">
                                                            <InputField
                                                                labelName={"Promo code"}
                                                                placeholderName={"Enter promo code"}
                                                                onChange={handlePromoCode}
                                                                onBlur={handlePromoCodeBlurCheck}
                                                                errorOccured={isPromoCodeErr}
                                                                errorMeesage={"enter valid promo code"}
                                                                value={`${promoCode}`}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="col-sm-5 ps-sm-1 pb-3">
                                                        <PrimaryButton
                                                            buttonName={"Apply"}
                                                            onClick={handleCheckPromoCodeFn}
                                                            loadingMessage={"Checking..."}
                                                            isLoading={promoCodeLoading}
                                                            style={{
                                                                width: "100%",
                                                                background:
                                                                    promoCodeLoading || promoCode === ""
                                                                        ? "lightgray"
                                                                        : "",
                                                                color:
                                                                    promoCodeLoading || promoCode === ""
                                                                        ? "grey"
                                                                        : "",
                                                                pointerEvents:
                                                                    promoCodeLoading || promoCode === ""
                                                                        ? "none"
                                                                        : "auto",
                                                                border: "none",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            }

                                            {
                                                // verifiedPromoCode && finalAmountAfterPromoCodeApplied == 0 ?
                                                //   <></> :
                                                <div className="row mx-0 p-3 bg-light">
                                                    <div className="col-12 px-0 d-flex align-items-center">
                                                        <span className="fs-6  text-black">
                                                            {`${callChargeDescription}`}
                                                        </span>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    <div className="col-lg-6 ps-lg-2 d-flex flex-column justify-content-between">
                                        <div className="mt-2 mb-4">
                                            {(verifiedPromoCode || isCreditsUsed) &&
                                                finalAmountAfterPromoCodeApplied == 0 ? (
                                                <div className="row mx-0">
                                                    <div className="col-12 px-0 text-center">
                                                        <span className="fs-4 fw-bold text-success">
                                                            {`${isCreditsUsed ? "Chilll credits" : "Promo code"} applied successfully`}
                                                        </span>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className="row mx-0">
                                                    <div className="col-12 px-0">
                                                        <label className="mb-1">
                                                            <strong>
                                                                {"Select your preferred payment method"}
                                                            </strong>
                                                        </label>

                                                        <div className="position-relative">
                                                            <div
                                                                className={`${isPaymentMethodErr && "border-danger"
                                                                    } w-100 border rounded d-flex justify-content-between align-items-center cursor-pointer`}
                                                                style={{
                                                                    height: "35px",
                                                                }}
                                                                onClick={() => {
                                                                    setToggleCardsMenu(!toggleCardsMenu);
                                                                    setIsPaymentMethodErr(false);
                                                                }}>
                                                                <div className="ps-3 ">
                                                                    {cardArr?.length > 0 ? (
                                                                        <>
                                                                            {cardArr?.map((element, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {element.is_default_card && (
                                                                                            <>
                                                                                                <span className="font-w600 text-black">
                                                                                                    {`${element?.card?.brand?.toUpperCase()} `}
                                                                                                </span>
                                                                                                <span className="text-black">
                                                                                                    {`*${element?.card?.last4}`}
                                                                                                </span>
                                                                                            </>
                                                                                        )}
                                                                                    </>
                                                                                );
                                                                            })}
                                                                        </>
                                                                    ) : (
                                                                        <span className="ps-2">
                                                                            {`Add new payment method`}
                                                                        </span>
                                                                    )}
                                                                </div>

                                                                <div
                                                                    className="fs-4 font-w600 d-flex justify-content-center align-items-center border-start"
                                                                    style={{ height: "25px", width: "35px" }}>
                                                                    <i class="bi bi-chevron-down"></i>
                                                                </div>
                                                            </div>

                                                            {isPaymentMethodErr && (
                                                                <small className="text-danger">{`please select payment method`}</small>
                                                            )}

                                                            {toggleCardsMenu && (
                                                                <div
                                                                    className="mt-1 w-100 border rounded d-flex flex-column align-items-center shadow"
                                                                    style={{
                                                                        pointerEvents: primaryCardLoading
                                                                            ? "none"
                                                                            : "auto",
                                                                        opacity: primaryCardLoading ? "0.5" : "1",
                                                                    }}
                                                                >
                                                                    {cardArr?.map((element, index) => {
                                                                        return (
                                                                            <>
                                                                                <div
                                                                                    key={index}
                                                                                    className="border-bottom p-2 text-black w-100 overlay-action-btn d-flex align-items-center cursor-pointer "
                                                                                    onClick={(e) =>
                                                                                        selectPrimaryCardFn(e, element)
                                                                                    }
                                                                                    style={{
                                                                                        pointerEvents: element?.is_default_card ? "none" : "auto",
                                                                                        opacity: element?.is_default_card ? "0.7" : "1",
                                                                                    }}
                                                                                >
                                                                                    <div className="mx-2">
                                                                                        <input
                                                                                            className="form-check-input"
                                                                                            style={{
                                                                                                display: "inline-block",
                                                                                            }}
                                                                                            name="selectCard"
                                                                                            type="radio"
                                                                                            value={`${element?.id}`}
                                                                                            onChange={(e) => {
                                                                                                selectPrimaryCardFn(e, element);
                                                                                            }}
                                                                                            checked={element?.is_default_card}
                                                                                        />
                                                                                    </div>

                                                                                    <div className="mt-1">
                                                                                        <span className="font-w600">
                                                                                            {`${element?.card?.brand?.toUpperCase()} `}
                                                                                        </span>
                                                                                        <span className="">
                                                                                            {`*${element?.card?.last4}`}
                                                                                        </span>
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        );
                                                                    })}

                                                                    <>
                                                                        <div
                                                                            className="align-items-center d-flex overlay-action-btn p-2 text-black w-100 cursor-pointer"
                                                                            onClick={() => {
                                                                                handleOpenAddNewPaymentMethod();
                                                                                setIsPaymentMethodErr(false);
                                                                            }}
                                                                        >
                                                                            <span className="fs-4 mx-2">
                                                                                <i className="bi bi-plus-circle-fill"></i>
                                                                            </span>
                                                                            <span className="font-w600">
                                                                                {`Add new payment method`}
                                                                            </span>
                                                                        </div>
                                                                    </>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>

                                        <div>
                                            <div>
                                                <div className="row mx-0">
                                                    <div className="col-12 px-0">
                                                        <PrimaryButton
                                                            buttonName={`CONFIRM PAYMENT`}
                                                            isLoading={backDropLoaderResp || scheduleLoader}
                                                            loadingMessage={"Loading..."}
                                                            onClick={() => {
                                                                // handleConfirmPay();
                                                                handlePaymentConfirmation();
                                                            }}
                                                            style={{
                                                                width: "100%",
                                                                background:
                                                                    "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                                                                border: "2px solid rgba(255, 154, 32, 1)",
                                                                boxShadow:
                                                                    "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <div className="row mx-0 mt-3">
                                        <div className="col-12 px-0 d-flex justify-content-center align-items-center flex-column text-black ">
                                            <div className="text-center">
                                                <span>{`By pressing the "CONFIRM PAYMENT" button, you agree to Chilll`}</span>
                                            </div>
                                            <div className="text-center">
                                                <a
                                                    className="terms-condition-link"
                                                    href="https://chilll.com/chilll-terms-conditions/"
                                                    target="_blank"
                                                    rel="noreferrer">
                                                    <span className="font-w600 cursor-pointer">{`Terms of Service`}</span>
                                                </a>
                                                <span>{` and `}</span>
                                                <a
                                                    className="terms-condition-link"
                                                    href="https://chilll.com/privacy-policy/"
                                                    target="_blank"
                                                    rel="noreferrer">
                                                    <span className="font-w600 cursor-pointer">{`Privacy Policy`}</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal to add new payment methods */}
            <Modal className="fade" show={addNewPaymentMethodTrigger} centered>
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <>
                                <div className="mx-0 row">
                                    <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                        <span
                                            onClick={() => {
                                                handleCloseAddNewPaymentMethod();
                                                setPaymentConfirmModal(true);
                                            }}
                                            className="cursor-pointer">
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className="mx-0 row mb-4">
                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                        <span>{"Payment methods"}</span>
                                    </div>
                                </div>

                                <div className="row mx-0 mb-2">
                                    <div className={`col-12 px-0 text-center`}>
                                        <span className="font-w600 fs-5">
                                            {supportedPaymentMethodsArr.length > 0
                                                ? "You can add a new payment method"
                                                : "No payment method available"}
                                        </span>
                                    </div>
                                </div>

                                {customLoadingForSupportedMethods ? (
                                    <>
                                        <SkeletonDivElement
                                            height={"80px"}
                                            marginBottom={"10px"}
                                            borderRadius={"0px"}
                                        />
                                        <SkeletonDivElement
                                            height={"80px"}
                                            marginBottom={"10px"}
                                            borderRadius={"0px"}
                                        />
                                        <SkeletonDivElement
                                            height={"80px"}
                                            marginBottom={"10px"}
                                            borderRadius={"0px"}
                                        />
                                    </>
                                ) : (
                                    <>
                                        {supportedPaymentMethodsArr?.length > 0 && (
                                            <div>
                                                {supportedPaymentMethodsArr?.map((element, index) => {
                                                    return (
                                                        <>
                                                            <div
                                                                key={index}
                                                                className="row mx-0 border shadow-sm p-3 mb-2 overlay-action-btn cursor-pointer"
                                                                style={{
                                                                    pointerEvents: element?.is_active_ysn
                                                                        ? "auto"
                                                                        : "none",
                                                                    opacity: element?.is_active_ysn ? 1 : 0.5,
                                                                }}
                                                                onClick={() => {
                                                                    handleCloseAddNewPaymentMethod();
                                                                    !customerID
                                                                        ? handleOpenAddCardFirstTime()
                                                                        : handleOpenAddNewCard();
                                                                }}>
                                                                <div
                                                                    className={`col-12 d-flex align-items-center`}>
                                                                    <div
                                                                        className="align-items-cente bg-light border d-flex fs-3 justify-content-center rounded-circle text-black"
                                                                        style={{ height: "35px", width: "35px" }}>
                                                                        <i class="align-self-center bi bi-gear-wide-connected"></i>
                                                                    </div>

                                                                    <div className="fs-4 font-w600 ps-3 text-black">
                                                                        <span>{element?.name_chr}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Modal to add new credit card first time */}
            <Modal className="fade" show={addCardFirstTimeTrigger} centered>
                <Modal.Body>
                    <div className="row mx-0">
                        <div className="col-12 px-0">
                            <>
                                <div className="mx-0 row">
                                    <div className="col-12 d-flex fs-4 justify-content-end px-0 text-black">
                                        <span
                                            onClick={() => handleCloseAddCardFirstTime()}
                                            className="cursor-pointer">
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className="mx-0 row mb-4">
                                    <div className="col-12 font-w600 fs-3 px-0 text-center text-black ">
                                        <span>{"Add new card"}</span>
                                    </div>
                                </div>

                                <>
                                    <form onSubmit={handleSubmitStripe}>
                                        <div>
                                            {/* <CardInput /> */}

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <label className={`font-w600 mb-1 ${cardNumberError ? 'text-red' : ''}`}>Card Number *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardNumberError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardNumberInput onChange={handleCardNumberChangeStripe} autocomplete="off" />
                                                    </div>
                                                    {cardNumberError && <div className="text-red fs-12">{cardNumberError}</div>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 mt-2'>
                                                <div className='col-6 pe-2'>
                                                    <label className={`font-w600 mb-1 ${cardExpiryError ? 'text-red' : ''}`}>Expiry Date *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardExpiryError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardExpiryInput onChange={handleCardExpiryChangeStripe} />
                                                    </div>
                                                    {cardExpiryError && <div className="text-red fs-12">{cardExpiryError}</div>}
                                                </div>

                                                <div className='col-6 ps-2'>
                                                    <label className={`font-w600 mb-1 ${cardCvcError ? 'text-red' : ''}`}>CVC *</label>
                                                    <div
                                                        style={{
                                                            padding: '10px',
                                                            border: cardCvcError ? '1px solid red' : '1px solid #DBDBDB',
                                                            borderRadius: '6px'
                                                        }}
                                                    >
                                                        <CardCvcInput onChange={handleCardCvcChangeStripe} />
                                                    </div>
                                                    {cardCvcError && <div className="text-red fs-12">{cardCvcError}</div>}
                                                </div>
                                            </div>

                                            <div className='row mx-0 mt-3'>
                                                <div className='col-12 px-0'>
                                                    <StandardInputField
                                                        labelName="Name on card"
                                                        placeholderName={'Name on card'}
                                                        type={'text'}
                                                        name={'cardHolder'}
                                                        value={cardInfo.cardHolder}
                                                        onChange={handleInputChange}
                                                        onFocus={handleInputFocus}
                                                        onBlur={handleCardHolderNameBlurCheck}
                                                        errorOccured={isCardHolderNameErr}
                                                        errorMeesage={'Enter valid cardholder name'}
                                                        isRequired={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className='row mx-0'>
                                                <div className='col-12 px-0'>
                                                    <StandardInputField
                                                        labelName={"Zip code"}
                                                        placeholderName={'Zip code'}
                                                        value={zipCode}
                                                        onChange={(e) => { handleZipCode(e) }}
                                                        onBlur={() => { handleZipCodeBlurCheck() }}
                                                        errorOccured={isZipCodeErr}
                                                        errorMeesage={`Enter valid zip code`}
                                                        isRequired={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-12 px-0  mt-2'>
                                                <PrimaryButton
                                                    onClick={(e) => handleSubmitStripe(e)}
                                                    buttonName={"ADD NEW CARD"}
                                                    type={"submit"}
                                                    loadingMessage={"LOADING..."}
                                                    isLoading={apiResponce}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, rgb(22, 186, 78) 1.99%, rgb(25, 223, 92) 99.97%)',
                                                        border: 'none',
                                                        boxShadow: 'rgba(45, 204, 99, 0.24) 0px 6px 12px 0px',
                                                    }}
                                                    disabled={!stripe}
                                                />
                                            </div>

                                        </div>

                                    </form>
                                </>

                                {/* <>
                                    <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
                                        <div className="row mx-0">
                                            <div className={`col-12 px-0 `}>
                                                <InputField
                                                    labelName="Card number"
                                                    placeholderName={"1234 1234 1234 1234"}
                                                    type={"text"}
                                                    name={"cardNumber"}
                                                    value={formatedNumber}
                                                    onChange={handleCardNumberChange}
                                                    onFocus={handleInputFocus}
                                                    maxLength={19}
                                                    onBlur={handleCardNumberBlurCheck}
                                                    errorOccured={isCardNumberErr}
                                                    errorMeesage={"Enter valid card number"}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mx-0 justify-content-between">
                                            <div className="col-6 px-0 pe-2">
                                                <InputField
                                                    labelName="MM/YY"
                                                    placeholderName={"MM/YY"}
                                                    type={"text"}
                                                    name={"expiryDate"}
                                                    value={cardInfo.expiryDate}
                                                    onChange={handleExpiryDateChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleCardExpBlurCheck}
                                                    errorOccured={isCardExpErr}
                                                    errorMeesage={"Enter valid exp. date"}
                                                />
                                            </div>

                                            <div className="col-6 px-0  ps-2">
                                                <InputField
                                                    labelName="CVV"
                                                    placeholderName={"CVV"}
                                                    type={"text"}
                                                    name={"cvc"}
                                                    value={cardInfo.cvc}
                                                    onChange={handleCVCChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleCardCVCBlurCheck}
                                                    errorOccured={isCardCVCErr}
                                                    errorMeesage={"Enter valid cvc"}
                                                    maxLength={4}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mx-0">
                                            <div className="col-12 px-0">
                                                <InputField
                                                    labelName="Name on card"
                                                    placeholderName={"Cardholder Name"}
                                                    type={"text"}
                                                    name={"cardHolder"}
                                                    value={cardInfo.cardHolder}
                                                    onChange={handleInputChange}
                                                    onFocus={handleInputFocus}
                                                    onBlur={handleCardHolderNameBlurCheck}
                                                    errorOccured={isCardHolderNameErr}
                                                    errorMeesage={"Enter valid cardholder name"}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mx-0 justify-content-between mt-2">
                                            <div className="col-12 px-0 mb-2">
                                                <PrimaryButton
                                                    onClick={(e) => handleSubmit(e)}
                                                    buttonName={"Add new card"}
                                                    type={"submit"}
                                                    loadingMessage={"Loading..."}
                                                    isLoading={apiResponce}
                                                    style={{
                                                        width: "100%",
                                                        background: "green",
                                                        border: "none",
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </form>
                                </> */}
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>



            {
                addNewCardTrigger && (
                    <AddNewCard
                        addNewCardTrigger={addNewCardTrigger}
                        handleCloseAddNewCard={handleCloseAddNewCard}
                    />
                )
            }

            {/* Modal for schedule call for later */}
            <>
                <Modal
                    className="fade"
                    show={scheduleModalTrigger}
                    // onHide={handleClose}
                    centered
                    size="">
                    {/* <Modal.Header style={{ borderBottom: 'none' }}>
            <Modal.Title style={{ display: 'flex', }}>

              {toggleForSchedule === 1 ? "Do you want to connect now or schedule for later?" :
                toggleForSchedule === 2 ? "Select date and time to schedule call for later" : ""}

            </Modal.Title>
            <Button
              variant=""
              className="btn-close btn-close-service"
              onClick={() => handleCloseDocScheduleModal()}
            >

            </Button>
          </Modal.Header> */}
                    <Modal.Body style={{ padding: "5px" }}>
                        <div className="row mx-0">
                            <div className="col-12 px-0 position-relative">
                                <div
                                    className="mx-0 row  schedule-modal-close-btn position-absolute text-hovered "
                                    style={{
                                        top: "5px",
                                        right: "10px",
                                    }}>
                                    <div className="col-12 d-flex fs-4 justify-content-end px-0">
                                        <span
                                            onClick={() => handleCloseDocScheduleModal()}
                                            className="cursor-pointer">
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className="row mx-0 ">
                                    <div
                                        className="col-sm-6 px-2 rounded-1"
                                        style={{
                                            background: "rgba(79, 93, 116, 1)",
                                        }}>
                                        <div className="mx-0 row m-2">
                                            <div className="col-12  px-0 text-center text-white fs-7 fw-light my-3 px-2">
                                                <span>{`Please note that the standard call duration is ${callDurationTimeLimit} minutes`}</span>
                                            </div>
                                        </div>

                                        <div className="mx-0 row">
                                            <div className="col-12  px-0 text-center">
                                                <InputField
                                                    type="time"
                                                    labelName={"Time"}
                                                    placeholder={"Date and time"}
                                                    value={currentTime}
                                                    // onChange={(e) => setCurrentTime(e.target.value)}
                                                    onChange={handleTimeChange}
                                                    errorOccured={isDateTimeErr}
                                                    errorMeesage={"Please enter date and time"}
                                                />
                                            </div>
                                        </div>

                                        <div className="row mx-0">
                                            <div className="col-12 px-0 d-flex justify-content-center">
                                                <DatePicker
                                                    selected={selectedDate}
                                                    onChange={handleDateChange}
                                                    // dateFormat="MMMM d, yyyy" // Format of the date displayed
                                                    // isClearable={true} // Shows a clear button to clear the selection
                                                    // showYearDropdown
                                                    scrollableMonthYearDropdown
                                                    inline // This prop makes the calendar always visible
                                                    style={{}}
                                                    minDate={today} // Disables all past dates before today
                                                    formatWeekDay={(nameOfDay) =>
                                                        nameOfDay.substring(0, 3)
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-6" style={{}}>
                                        <div className="row h-100 w-100">
                                            <div className="col-12 p-3 d-flex flex-column justify-content-between">
                                                <div>
                                                    <div className="mx-0 row text-black my-2">
                                                        <div className="col-12 px-0 text-center d-flex align-items-cente justify-content-center">
                                                            <img
                                                                src={calendarImg}
                                                                alt="Calendar"
                                                                style={{ height: "70px", width: "70px" }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="mx-0 row text-black mb-3">
                                                        <div className="col-12 font-w600 fs-3 px-0 text-center">
                                                            <span>{"Schedule a call"}</span>
                                                        </div>
                                                    </div>

                                                    <div className="mx-0 row mb-3">
                                                        <div className="col-12  px-0 text-center">
                                                            <span>
                                                                {
                                                                    "Set the desired date and time for your video call or set it to go live right now"
                                                                }
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="mx-0 row">
                                                        <div
                                                            className="col-12  px-0 text-center rounded p-2 d-flex align-items-center justify-content-center flex-column"
                                                            style={{
                                                                background: "rgba(244, 248, 255, 1)",
                                                                border: "1px solid rgba(199, 212, 234, 1)",
                                                            }}>
                                                            <span>{`Scheduled date & time`}</span>
                                                            <span className="fs-6 text-black">{`${formatUnixTimestamp(
                                                                convertToUnixTime()
                                                            )}`}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div>
                                                    <div className="mx-0 row mt-3">
                                                        <div className="col-12  px-0 text-center">
                                                            <PrimaryButton
                                                                buttonName={"SAVE CHANGES"}
                                                                onClick={() => {
                                                                    if (paymentGatewayFlag) {
                                                                        // setPaymentModal(true)
                                                                        handleOpenPaymentModalTrigger();
                                                                        setIsScheduledCall(true);
                                                                    } else {
                                                                        // submitFeedback();
                                                                        handleSubmitSchedule()
                                                                    }
                                                                }}
                                                                isLoading={scheduleLoader}
                                                                loadingMessage={"Saving..."}
                                                                style={{
                                                                    width: "100%",
                                                                    background:
                                                                        "linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)",
                                                                    border: "2px solid rgba(255, 154, 32, 1)",
                                                                    boxShadow:
                                                                        "0px 6px 12px 0px rgba(255, 154, 32, 0.24)",
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>

              <div style={{ width: '100%', marginBottom: '5px', textAlign: 'center' }}>
                <p style={{ fontSize: '14px', fontWeight: '600', color: 'black' }}>{"Select date and time to schedule call for later"}</p>
              </div>


              <div style={{ width: '70%', marginBottom: '15px' }}>
                <InputField
                  type="datetime-local"
                  labelName={"Date and time"}
                  placeholder={"Date and time"}
                  value={dateTime}
                  onChange={handleDateTime}
                  errorOccured={isDateTimeErr}
                  errorMeesage={"Please enter date and time"}
                />
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
                <PrimaryButton
                  buttonName={"Submit"}
                  onClick={() => handleSubmitSchedule()}
                  isLoading={scheduleLoader}
                  loadingMessage={"Submiting..."}
                />
              </div>
            </div> */}
                    </Modal.Body>
                </Modal>
            </>

            {/* Modal for Schedule call success response */}
            <>
                <Modal
                    className="fade"
                    show={responseScheduleSuccess}
                    // onHide={handleClose}
                    centered
                >
                    {/* <Modal.Header style={{ borderBottom: "none" }}>
                        <Button
                            variant=""
                            className="btn-close btn-close-service"
                            onClick={() => handleCloseScheduleSuccess()}></Button>
                    </Modal.Header> */}
                    <Modal.Body>
                        <div className='col-12 d-flex fs-4 justify-content-end px-0'>
                            <span
                                onClick={() => handleCloseScheduleSuccess()}
                                className='cursor-pointer text-hovered text-black'
                            >
                                <i className="bi bi-x-lg"></i>
                            </span>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                position: "relative",
                                alignItems: "center",
                                textAlign: "center",
                            }}>
                            <img src={serviceImg} alt="" style={{ maxWidth: "150px" }} />

                            <span
                                style={{
                                    margin: "3px 20px",
                                    fontSize: "16px",
                                    fontWeight: 700,
                                    color: "black",
                                }}>
                                Thank you for creating service request.
                            </span>
                            <span style={{ margin: '5px 20px', fontSize: '14px', fontWeight: 500, color: 'black', }}>
                                Our Professional will get back to you.
                            </span>
                        </div>
                    </Modal.Body>
                </Modal>
            </>





            {backDropLoaderResp && <DummyBackdropLoader />}
            {backDropLoaderRejectedCase && <BackDropLoaderRejectedCase openLoader={backDropLoaderRejectedCase} descriptionVal={inventoryDesc} modelNumVal={inventoryModel} timeSlotArr={timeSlotArr} communicationModeArr={comminicationModeArr} />}
            {backDropLoaderStatus && <BackDrop showUpdate={true} openLoader={backDropLoaderStatus} descriptionVal={inventoryDesc} modelNumVal={inventoryModel} timeSlotArr={timeSlotArr} communicationModeArr={comminicationModeArr} />}
            {errBackDropLoaderResp && <ErrorBackdropLoader resMessage={responceMsg} />}
            {updateServiceRequestStatus && <UpdateServiceRequest objectCategoryName={categoryName || "Inspection"} descriptionVal={inventoryDesc} modelNumVal={inventoryModel} timeSlotArr={timeSlotArr} communicationModeArr={comminicationModeArr} attachedImg={inventoryImage} />}



            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}

        </>
    );
};

export default HomeMaintenance;
